import { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Form,
  Container,
  Button,
  Card,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { ShimmerSimpleGallery } from "react-shimmer-effects";
import { batch, useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";

import "./PurchaseProfileForm.css";

import PurchaseProfileBuyerAgentDesc from "./PurchaseProfileBuyerAgentDesc";
import PurchaseProfileIndividualBusinessEntity from "./PurchaseProfileIndividualBusinessEntity";
import {
  cifVerifyLicenseDetails,
  getPurchaseProfileByUserId,
  getUserProfile,
  saveCIFTemplate,
  validateAddress,
} from "@/api/bid";
import validateForm from "./validateProfileForm";
import validateAgentForm from "./validateAgentForm";
import { isPhoneNoInUse } from "@/api/bid";
import { isPhoneNoVerified } from "@/api/bid";
import { cityList } from "@/api/bid";
import {
  deletePurchaseProfile,
  fetchPurchaseProfileDocs,
  getPurchaseProfileCMS,
} from "@/api/myPurchaseProfile";
import { toast } from "react-toastify";
import LoadingText from "@/components/loader/LoadingText";
import LoadedText from "@/components/loader/LoadedText";
import { isValidSession } from "@/api/auth";
import {
  convertMMDDYYtoYYYYMMDD,
  convertYYYYMMDDtoMMDDYYYY,
  formatDisplayDate,
} from "@/utils/dateFormatter";
import DocumentUpload from "./components/doc-upload-field/DocumentUpload";
import DeletePopupModal from "../components/delete-modal/DeletePopupModal";
import SuggestionInput from "./components/suggestion-input-field/SuggestionInput";
import PhoneInputField from "./components/phone-input-field/PhoneInputField";
import PhoneVerificationModal from "./components/phone-veirfy-modal/PhoneVerificationModal";
import { validateVerificationCode } from "@/api/LoginSignup";
import { formatPhoneNumber } from "@/utils/phoneNumberFormatter";
import {
  setLoginCallLocation,
  setLoginModal,
  setLoginTab,
} from "@/redux/login/loginSlice";
import { selectStateList } from "@/redux/common/commonSlice";
import { setProfileInfo } from "@/redux/user/userSlice";
import { setUserDetailsSlices } from "@/redux/auth/authSlice";
import { trackApiCall, trackButtonClick } from "@/utils/analytics";

const PurchaseProfileForm = () => {
  const pageRef = useRef();
  const accordian1Ref = useRef();
  const accordian2Ref = useRef();
  const accordian3Ref = useRef();
  const profileNameRef = useRef({});
  const accordianRef = useRef({});

  const buyerFormRef = useRef({});
  const coBuyerFormRef = useRef({});
  const agentFormRef = useRef({});

  const buyerDocRef = useRef({});
  const coBuyerDocRef = useRef({});

  const dispatch = useDispatch();

  const stateList = useSelector(selectStateList);
  const user = useSelector((state) => state?.user);

  const [cmsData, setCmsData] = useState("");
  const [locationData, setLocationData] = useState({
    buyer: {
      state: null,
      cities: [],
      loaded: false,
    },
    coBuyer: {
      state: null,
      cities: [],
      loaded: false,
    },
    agent: {
      state: null,
      cities: [],
      loaded: false,
    },
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isCodeVerGoing, setIsCodeVerGoing] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const [isFormSubmitLoading, setIsFormSubmitLoading] = useState(false);

  const [apiError, setApiError] = useState(null);
  const [isPhoneVerGoing, setIsPhoneVerGoing] = useState(false);
  const [isPhoneVerified, setIsPhoneVerified] = useState({
    buyerVerificationRequired: false,
    agentVerificationRequired: false,
    buyerNumVerified: true,
    agentNumVerified: true,
  });

  const [formErrors, setFormErrors] = useState({});
  const [profileError, setProfileError] = useState("");

  const [errorValidate, setErrorValidate] = useState({
    isValid: true,
    errors: {},
  });

  const [coBuyerErrorValidate, setCoBuyerErrorValidate] = useState({
    isValid: true,
    errors: {},
  });

  const [agentErrorValidate, setAgentErrorValidate] = useState({
    isValid: true,
    errors: {},
  });

  const [hasCobuyer, setHasCoBuyer] = useState("No");
  const [individual, setIndividual] = useState("Individual");
  const [individualCobuyer, setIndividualCobuyer] =
    useState("IndividualCobuyer");

  const [selectedDescription, setSelectedDescription] = useState("");
  const [agentBuyingForSelf, setAgentBuyingForSelf] = useState("");
  const [buyerRepresentedByAgent, setBuyerRepresentedByAgent] = useState("");

  const [buyerUploadedFiles, setBuyerUploadedFiles] = useState([]);
  const [coBuyerUploadedFiles, setCoBuyerUploadedFiles] = useState([]);
  const [buyerBusinessDocId, setBuyerBusinessDocId] = useState([]);
  const [coBuyerBusinessDocId, setCoBuyerBusinessDocId] = useState([]);

  const [templateId, setTemplateId] = useState(null);
  const [selectedCardIndex, setSelectedCardIndex] = useState(null);
  const [showAccordianProfile, setShowAccordianProfile] = useState(false);

  const [showAccordian1, setShowAccordian1] = useState(false);
  const [showAccordian2, setShowAccordian2] = useState(false);
  const [showAccordian3, setShowAccordian3] = useState(false);
  const [showAccordian1Body, setShowAccordian1Body] = useState(false);
  const [showAccordian2Body, setShowAccordian2Body] = useState(false);
  const [showAccordian3Body, setShowAccordian3Body] = useState(false);
  const [accordian1EditBtnActive, setAccordian1EditBtnActive] = useState(false);
  const [accordian2EditBtnActive, setAccordian2EditBtnActive] = useState(false);
  const [accordian3EditBtnActive, setAccordian3EditBtnActive] = useState(false);
  const [accordian1FormCompleted, setAccordian1FormCompleted] = useState(false);
  const [accordian2FormCompleted, setAccordian2FormCompleted] = useState(false);
  const [accordian3FormCompleted, setAccordian3FormCompleted] = useState(false);
  const [isAccordianDataPreFilled, setIsAccordianDataPreFilled] =
    useState(false);

  const [isNewTemplate, setIsNewTemplate] = useState(null);
  const [isDeleteModalActive, setIsDeleteModalActive] = useState(false);

  const [profileName, setProfileName] = useState("");
  const [purchaseProfileUser, setPurchaseProfileUser] = useState([]);
  const [showLicenseTooltip, setShowLicenseTooltip] = useState(false);

  const [buyerFormData, setBuyerFormData] = useState({
    firstName: "",
    lastName: "",
    middleName: "",
    corporationName: "",
    emailId: "",
    address1: "",
    address2: "",
    state: "",
    city: "",
    zip: "",
    phoneNumber: "",
  });

  const [coBuyerFormData, setCoBuyerFormData] = useState({
    firstName: "",
    lastName: "",
    middleName: "",
    corporationName: "",
    emailId: "",
    address1: "",
    address2: "",
    state: "",
    city: "",
    zip: "",
    phoneNumber: "",
  });

  const [agentInfo, setAgentInfo] = useState({
    firstName: "",
    lastName: "",
    middleName: "",
    corporationName: "",
    address1: "",
    state: "",
    city: "",
    zip: "",
    emailId: "",
    phoneNumber: "",
    individualLicencenNumber: "",
    individualLicenceExpiryDate: "",
    corporationState: "",
    individualLicenceState: "",
    corporationLicenceNumber: "",
  });

  const [verificationModalState, setVerificationModalState] = useState({
    isOpen: false,
    phoneNumber: "",
    type: null,
  });

  const purchaseProfileFormData = [
    {
      id: 0,
      label: "First Name",
      placeholder: "First Name",
      maxLength: 40,
      type: "text",
      required: true,
      editLink: false,
      formValueLabel: "firstName",
    },
    {
      id: 1,
      label: "Last Name",
      placeholder: "Last Name",
      maxLength: 40,
      type: "text",
      required: true,
      editLink: false,
      formValueLabel: "lastName",
    },
    {
      id: 2,
      label: "Middle Name",
      placeholder: "Middle Name",
      maxLength: 40,
      type: "text",
      required: false,
      editLink: false,
      formValueLabel: "middleName",
    },
    {
      id: 3,
      label: "Agency Name",
      placeholder: "Agency Name",
      maxLength: 40,
      type: "text",
      required: true,
      editLink: false,
      formValueLabel: "corporationName",
    },
    {
      id: 4,
      label: "Individual Address",
      placeholder: "Individual Address",
      maxLength: 100,
      type: "text",
      required: true,
      editLink: false,
      formValueLabel: "address1",
    },
    {
      id: 5,
      label: "Corporation Name",
      placeholder: "Corporation Name",
      maxLength: 40,
      type: "text",
      required: true,
      editLink: false,
      formValueLabel: "corporationName",
    },
    {
      id: 6,
      label: "Corporation Address",
      placeholder: "Corporation Address",
      maxLength: 40,
      type: "text",
      required: true,
      editLink: false,
      formValueLabel: "address1",
    },
    {
      id: 7,
      label: "State",
      placeholder: "State",
      maxLength: 40,
      type: "dropdown",
      required: true,
      editLink: false,
      formValueLabel: "state",
      options: [],
    },
    {
      id: 8,
      label: "City",
      placeholder: "City",
      maxLength: 40,
      type: "text",
      required: true,
      editLink: false,
      formValueLabel: "city",
      options: [],
    },
    {
      id: 9,
      label: "Zip Code",
      placeholder: "Zip Code",
      maxLength: 5,
      type: "number",
      required: true,
      editLink: false,
      formValueLabel: "zip",
    },
    {
      id: 10,
      label: "Email",
      placeholder: "Email",
      maxLength: 40,
      type: "email",
      required: true,
      editLink: true,
      formValueLabel: "emailId",
    },
    {
      id: 11,
      label: "Phone Number",
      placeholder: "Phone Number",
      maxLength: 14,
      type: "tel",
      required: true,
      editLink: false,
      formValueLabel: "phoneNumber",
    },
    {
      id: 12,
      label: "Upload Document",
      placeholder: "choose file",
      maxLength: 40,
      type: "file",
      required: true,
      editLink: false,
      accept: ".pdf,.doc",
      formValueLabel: "documentId",
    },
    {
      id: 13,
      label: "Individual Licence Number",
      placeholder: "Individual Licence Number",
      maxLength: 40,
      type: "text",
      required: true,
      editLink: false,
      formValueLabel: "individualLicencenNumber",
    },
    {
      id: 14,
      label: "Individual Licence Expiry Date",
      placeholder: "Individual Licence Expiry Date",
      maxLength: 10,
      type: "date",
      required: true,
      editLink: false,
      formValueLabel: "individualLicenceExpiryDate",
    },
    {
      id: 15,
      label: "Corporation Licence Number",
      placeholder: "Corporation Licence Number",
      maxLength: 20,
      type: "text",
      required: false,
      editLink: false,
      formValueLabel: "corporationLicenceNumber",
    },
    {
      id: 16,
      label: "Select individual Licence State",
      placeholder: "Select individual Licence State",
      maxLength: 40,
      type: "dropdown",
      required: true,
      editLink: false,
      formValueLabel: "individualLicenceState",
    },
    {
      id: 17,
      label: "Select corporation state",
      placeholder: "Select corporation state",
      maxLength: 40,
      type: "dropdown",
      required: false,
      editLink: false,
      formValueLabel: "corporationState",
    },
    {
      id: 18,
      label: "Address",
      placeholder: "Address",
      maxLength: 40,
      type: "text",
      required: true,
      editLink: false,
      formValueLabel: "address1",
    },
  ];

  const individualEntityField = [
    purchaseProfileFormData[0],
    purchaseProfileFormData[1],
    purchaseProfileFormData[2],
    purchaseProfileFormData[4],
    purchaseProfileFormData[7],
    purchaseProfileFormData[8],
    purchaseProfileFormData[9],
    purchaseProfileFormData[10],
    purchaseProfileFormData[11],
  ];

  const businessEntityField = [
    purchaseProfileFormData[0],
    purchaseProfileFormData[1],
    purchaseProfileFormData[2],
    purchaseProfileFormData[5],
    purchaseProfileFormData[6],
    purchaseProfileFormData[7],
    purchaseProfileFormData[8],
    purchaseProfileFormData[9],
    purchaseProfileFormData[10],
    purchaseProfileFormData[11],
    purchaseProfileFormData[12],
  ];

  const agentInfoField = [
    purchaseProfileFormData[0],
    purchaseProfileFormData[1],
    purchaseProfileFormData[2],
    purchaseProfileFormData[3],
    purchaseProfileFormData[18],
    purchaseProfileFormData[7],
    purchaseProfileFormData[8],
    purchaseProfileFormData[9],
    purchaseProfileFormData[10],
    purchaseProfileFormData[11],
    purchaseProfileFormData[13],
    purchaseProfileFormData[14],
    purchaseProfileFormData[16],
    purchaseProfileFormData[15],
    purchaseProfileFormData[17],
  ];

  const fetchUserProfile = async () => {
    try {
      const userProfile = await getUserProfile();
      const userDetails = userProfile?.data?.userDetails;

      dispatch(setProfileInfo(userProfile.data));
      dispatch(setUserDetailsSlices(userProfile?.data));

      if (!userDetails) {
        console.warn("No user details found in response");
        return;
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  const updateFormData = (shouldClear, isAgent = false) => {
    const baseData = shouldClear
      ? {
          firstName: "",
          lastName: "",
          middleName: "",
          corporationName: "",
          emailId: "",
          address1: "",
          address2: "",
          state: "",
          city: "",
          zip: "",
          phoneNumber: "",
        }
      : {
          firstName: user.user.userFirstName || "",
          middleName: user.user.userMiddleName || "",
          lastName: user.user.userLastName || "",
          corporationName: isAgent ? user?.profileInfo?.companyProfileDto?.brokerageName || "" : "",
          emailId: user.user.userEmailId || "",
          phoneNumber: user.user.primaryPhone || "",
          address1: user.user.address1 || "",
          state: user.user.state || "",
          city: user.user.city || "",
          zip: user.user.zip || "",
        };

    // Add agent-specific fields if isAgent is true
    if (isAgent) {
      return {
        ...baseData,
        // corporationName: "",
        individualLicencenNumber: "",
        individualLicenceExpiryDate: "",
        individualLicenceState: "",
        corporationState: "",
        corporationLicenceNumber: "",
      };
    }

    return baseData;
  };

  const validateRadioSelections = () => {
    let isValid = true;
    const isBuyer = selectedDescription === "Buyer";
    const isAgent = selectedDescription === "Agent";

    const newErrors = {
      description: "",
      buyerRepresentedByAgent: "",
      agentBuyingForSelf: "",
    };

    // Validate main description selection
    if (!selectedDescription) {
      newErrors.description = "Please choose an option";
      isValid = false;
    }

    // when all are not selcted
    if (
      !isBuyer &&
      !isAgent &&
      !buyerRepresentedByAgent &&
      !agentBuyingForSelf
    ) {
      newErrors.buyerRepresentedByAgent = "Please choose an option";
      newErrors.agentBuyingForSelf = "Please choose an option";
      isValid = false;
    }

    // Validate based on the selected description
    if (isBuyer && !buyerRepresentedByAgent) {
      newErrors.buyerRepresentedByAgent = "Please choose an option";
      isValid = false;
    }

    if (isAgent && !agentBuyingForSelf) {
      newErrors.agentBuyingForSelf = "Please choose an option";
      isValid = false;
    }

    setFormErrors(newErrors);
    return isValid;
  };

  // Radio button handlers
  const handleDescriptionChange = (e) => {
    const { value } = e.target;

    const isBuyer = value === "Buyer";
    const isAgent = value == "Agent";

    trackButtonClick({
      eventName: "description_select_click",
      eventParams: { value },
      eventCategory: "my-shopper",
      eventSource: "on radio button click buyer/agent",
      eventLabel: "SRC : Buyer Dashboard My Purchase Profile",
    });

    setSelectedDescription(value);
    setBuyerRepresentedByAgent(buyerRepresentedByAgent);
    setAgentBuyingForSelf(agentBuyingForSelf);

    if (isBuyer) {
      if (buyerRepresentedByAgent !== "") {
        trackButtonClick({
          eventName: "buyer_role_selection",
          eventParams: { is_buyer: isBuyer ? "Y" : "N" },
          eventCategory: "my-shopper",
          eventSource: "on radio button click buyer/agent",
          eventLabel: "SRC : Buyer Dashboard My Purchase Profile",
        });
      }
      setShowAccordian3(buyerRepresentedByAgent === "Yes");
      setBuyerFormData(updateFormData(false, false));
      setAgentInfo(updateFormData(true, true));
      setIsPhoneVerified({
        buyerNumVerified: false,
        agentNumVerified: true,
        buyerVerificationRequired: true,
        agentVerificationRequired: false,
      });
      handlePhoneVerification(user.user.primaryPhone, "buyer");
    }

    if (isAgent) {
      setShowAccordian3(agentBuyingForSelf === "No");

      if (agentBuyingForSelf === "Yes") {
        trackButtonClick({
          eventName: "buyer_agent_role_selection",
          eventParams: { is_agent: isAgent ? "Y" : "N" },
          eventCategory: "my-shopper",
          eventSource: "on radio button click buyer/agent",
          eventLabel: "SRC : Buyer Dashboard My Purchase Profile",
        });

        setBuyerFormData(updateFormData(false, false));
        setAgentInfo(updateFormData(true, true));
        setIsPhoneVerified({
          buyerNumVerified: false,
          agentNumVerified: true,
          buyerVerificationRequired: true,
          agentVerificationRequired: false,
        });
        handlePhoneVerification(user.user.primaryPhone, "buyer");
      }
      if (agentBuyingForSelf === "No") {
        trackButtonClick({
          eventName: "buyer_agent_role_selection",
          eventParams: { is_agent: isAgent ? "Y" : "N" },
          eventCategory: "my-shopper",
          eventSource: "on radio button click buyer/agent",
          eventLabel: "SRC : Buyer Dashboard My Purchase Profile",
        });

        setBuyerFormData(updateFormData(true, false));
        setAgentInfo(updateFormData(false, true));
        setIsPhoneVerified({
          buyerNumVerified: true,
          agentNumVerified: false,
          buyerVerificationRequired: false,
          agentVerificationRequired: true,
        });
        handlePhoneVerification(user.user.primaryPhone, "agent");
      }
    }

    setFormErrors((prev) => ({ ...prev, description: "" }));
  };

  const handleBuyingForSelfChange = (e) => {
    const { value } = e.target;

    const isBuyer = selectedDescription === "Buyer";
    const isAgent = selectedDescription === "Agent";

    setBuyerRepresentedByAgent(value);
    setAgentBuyingForSelf(value);

    if (isBuyer) {
      trackButtonClick({
        eventName: "buyer_role_selection",
        eventParams: { is_buyer: isBuyer ? "Y" : "N" },
        eventCategory: "my-shopper",
        eventSource: "on radio button click buyer/agent",
        eventLabel: "SRC : Buyer Dashboard My Purchase Profile",
      });
      setShowAccordian3(value === "Yes");
      setBuyerFormData(updateFormData(false, false));
      setAgentInfo(updateFormData(true, true));
      setIsPhoneVerified({
        buyerNumVerified: false,
        agentNumVerified: true,
        buyerVerificationRequired: true,
        agentVerificationRequired: false,
      });
      handlePhoneVerification(user.user.primaryPhone, "buyer");
    }

    if (isAgent) {
      trackButtonClick({
        eventName: "buyer_agent_role_selection",
        eventParams: { is_agent: isAgent ? "Y" : "N" },
        eventCategory: "my-shopper",
        eventSource: "on radio button click buyer/agent",
        eventLabel: "SRC : Buyer Dashboard My Purchase Profile",
      });
      setShowAccordian3(value === "No");
      if (value === "Yes") {
        setBuyerFormData(updateFormData(false, false));
        setAgentInfo(updateFormData(true, true));
        setIsPhoneVerified({
          buyerNumVerified: false,
          agentNumVerified: true,
          buyerVerificationRequired: true,
          agentVerificationRequired: false,
        });
        handlePhoneVerification(user.user.primaryPhone, "buyer");
      }
      if (value === "No") {
        setBuyerFormData(updateFormData(true, false));
        setAgentInfo(updateFormData(false, true));
        setIsPhoneVerified({
          buyerNumVerified: true,
          agentNumVerified: false,
          buyerVerificationRequired: false,
          agentVerificationRequired: true,
        });
        handlePhoneVerification(user.user.primaryPhone, "agent");
      }
    }

    setFormErrors((prev) => ({
      ...prev,
      agentBuyingForSelf: "",
      buyerRepresentedByAgent: "",
    }));
  };

  const handleCheckProfileName = () => {
    if (profileError) return;
    if (profileName === "") {
      setProfileError("Invalid Name");
      return;
    }
    setProfileError("");
    // check from the existing template name which is stored in purchase profile user
    if (!Array.isArray(purchaseProfileUser) || purchaseProfileUser.length === 0)
      return;

    const match = purchaseProfileUser.some((item) => {
      // If editing an existing template, don't compare with its own name
      if (!isNewTemplate && item.templateId === templateId) {
        return false;
      }
      return item.templateName?.toLowerCase() === profileName?.toLowerCase();
    });

    if (match) {
      setProfileError("Template name already taken.");
      return true;
    }

    return false;
  };

  const handleProfileNameChange = (e) => {
    const { type } = e;
    const { value } = e.target;

    setProfileName(value);

    if (value) {
      const validationErrors = validateForm({
        formData: { profileName: value },
        individual: "Individual",
        customMessage: true,
      });

      if (validationErrors.isValid) {
        setProfileError("");
      } else {
        setProfileError(validationErrors.errors["profileName"]);
      }
    } else {
      if (type === "blur") {
        setProfileError("Invalid Name");
      } else {
        setProfileError("");
      }
    }
  };

  const handleIndividualChange = (event) => {
    const value = event.target.value;
    setIndividual(value);

    trackButtonClick({
      eventName: "user_select",
      eventParams: { value },
      eventCategory: "my-shopper",
      eventSource: "on radio button click individual type",
      eventLabel: "SRC : Buyer Dashboard My Purchase Profile",
    });

    if (value === "Individual") {
      setBuyerBusinessDocId([]);
      setBuyerUploadedFiles([]);
      setBuyerFormData((prev) => ({
        ...prev,
        corporationName: "",
      }));

      // clear error as well from errorValidate state if any
      setErrorValidate((prev) => {
        const updatedErrors = { ...prev.errors };
        delete updatedErrors["corporationName"];
        return {
          isValid: Object.keys(updatedErrors).length === 0,
          errors: updatedErrors,
        };
      });
    }
  };

  const handleCoBuyerChange = (e) => {
    const { value } = e.target;
    setHasCoBuyer(value);
  };

  const handleBuyerFieldChange = async (e) => {
    let { name, value, required, placeholder } = e.target;

    if (name === "zip" && value.length > 5) {
      value = value.slice(0, 5);
    }

    setBuyerFormData((prevState) => ({
      ...prevState,
      [name]: name === "emailId" ? value.toLowerCase() : value,
    }));

    // Check if field is required and empty
    if (required) {
      const validationErrors = validateForm({
        formData: { [name]: value },
        individual: individual,
        customMessage: true,
      });

      if (!validationErrors.isValid) {
        setErrorValidate((prev) => ({
          isValid: false,
          errors: {
            ...prev.errors,
            [name]: validationErrors.errors[name],
          },
        }));
      } else {
        setErrorValidate((prev) => {
          const updatedError = { ...prev.errors };
          delete updatedError[name];
          return {
            isValid: Object.keys(updatedError).length === 0,
            errors: updatedError,
          };
        });
      }
    }

    // Check for same email id for buyer and agent
    if (
      selectedDescription === "Agent" &&
      agentBuyingForSelf === "No" &&
      name === "emailId"
    ) {
      if (value.toLowerCase() === agentInfo.emailId.toLowerCase()) {
        setErrorValidate((prev) => ({
          isValid: false,
          errors: {
            ...prev.errors,
            emailId: "Buyer and Agent email shouldn't be same.",
          },
        }));
      } else {
        setErrorValidate((prev) => {
          const updatedErrors = { ...prev.errors };
          delete updatedErrors["emailId"];
          return {
            isValid: Object.keys(updatedErrors).length === 0,
            errors: updatedErrors,
          };
        });
      }
    }

    if (name === "state") {
      setBuyerFormData((prev) => ({
        ...prev,
        city: "",
      }));
    }

    // check for phone verification if requried
    if (name === "phoneNumber") {
      const digitsOnly = value?.replace(/[^\d]/g, "");
      if (
        digitsOnly.length === 10 &&
        isPhoneVerified.buyerVerificationRequired
      ) {
        handlePhoneVerification(digitsOnly, "buyer");
      }
    }
  };

  const handleCoBuyerFieldChange = async (e) => {
    let { name, value, required, placeholder } = e.target;

    if (name === "zip" && value.length > 5) {
      value = value.slice(0, 5);
    }

    setCoBuyerFormData((prevState) => ({
      ...prevState,
      [name]: name === "emailId" ? value.toLowerCase() : value,
    }));

    // Check if field is required and empty
    if (required) {
      const validationErrors = validateForm({
        formData: { [name]: value },
        individual: individualCobuyer,
        customMessage: true,
      });

      if (!validationErrors.isValid) {
        setCoBuyerErrorValidate((prev) => ({
          isValid: false,
          errors: {
            ...prev.errors,
            [name]: validationErrors.errors[name],
          },
        }));
      } else {
        setCoBuyerErrorValidate((prev) => {
          const updatedErrors = { ...prev.errors };
          delete updatedErrors[name];
          return {
            isValid: Object.keys(updatedErrors).length === 0,
            errors: updatedErrors,
          };
        });
      }
    }

    // Check for same email Id
    if (hasCobuyer === "Yes" && name === "emailId") {
      if (value.toLowerCase() === buyerFormData.emailId.toLowerCase()) {
        setCoBuyerErrorValidate((prev) => ({
          isValid: false,
          errors: {
            ...prev.errors,
            emailId: "Buyer and Co-Buyer email shouldn't be same.",
          },
        }));
      } else {
        setCoBuyerErrorValidate((prev) => {
          const updatedErrors = { ...prev.errors };
          delete updatedErrors["emailId"];
          return {
            isValid: Object.keys(updatedErrors).length === 0,
            errors: updatedErrors,
          };
        });
      }
    }

    if (name === "state") {
      setCoBuyerFormData((prev) => ({
        ...prev,
        city: "",
      }));
    }
  };

  const handleAgentFieldChange = (e) => {
    let { name, value, required, placeholder } = e.target;

    if (name === "zip" && value.length > 5) {
      value = value.slice(0, 5);
    }

    setAgentInfo((prevState) => ({
      ...prevState,
      [name]: name === "emailId" ? value.toLowerCase() : value,
    }));

    // Check if field is required and empty
    if (required) {
      const validationErrors = validateAgentForm({
        formData: { [name]: value },
        customMessage: true,
      });

      if (!validationErrors.isValid) {
        setAgentErrorValidate((prev) => ({
          isValid: false,
          errors: {
            ...prev.errors,
            [name]: validationErrors.errors[name],
          },
        }));
      } else {
        setAgentErrorValidate((prev) => {
          const updatedErrors = { ...prev.errors };
          delete updatedErrors[name];
          return {
            isValid: Object.keys(updatedErrors).length === 0,
            errors: updatedErrors,
          };
        });
      }
    }

    // Check for same email id for buyer and agent
    if (
      selectedDescription === "Buyer" &&
      buyerRepresentedByAgent === "Yes" &&
      name === "emailId"
    ) {
      if (value.toLowerCase() === buyerFormData.emailId.toLowerCase()) {
        setAgentErrorValidate((prev) => ({
          isValid: false,
          errors: {
            ...prev.errors,
            emailId: "Buyer and Agent email shouldn't be same.",
          },
        }));
      } else {
        setAgentErrorValidate((prev) => {
          const updatedErrors = { ...prev.errors };
          delete updatedErrors["emailId"];
          return {
            isValid: Object.keys(updatedErrors).length === 0,
            errors: updatedErrors,
          };
        });
      }
    }

    if (name === "state") {
      setAgentInfo((prev) => ({
        ...prev,
        city: "",
      }));
    }

    // check for phone verification if requried
    if (name === "phoneNumber") {
      const digitsOnly = value?.replace(/[^\d]/g, "");
      if (
        digitsOnly.length === 10 &&
        isPhoneVerified.agentVerificationRequired
      ) {
        handlePhoneVerification(digitsOnly, "agent");
      }
    }
  };

  const handleVerifyPhone = async (code) => {
    try {
      setIsCodeVerGoing(true);
      const digitsOnly = verificationModalState.phoneNumber?.replace(
        /[^\d]/g,
        ""
      );
      const verificationData = {
        phoneNumber: digitsOnly,
        verificationCode: code,
      };
      const response = await validateVerificationCode(verificationData);
      const { type } = verificationModalState;
      const isSuccess = response?.status === "SUCCESS" && response?.data;

      const setErrorState =
        type === "agent" ? setAgentErrorValidate : setErrorValidate;

      if (isSuccess) {
        // Update error state
        setErrorState((prev) => {
          const updatedErrors = { ...prev.errors };
          delete updatedErrors["phoneNumber"];
          return {
            isValid: Object.keys(updatedErrors).length === 0,
            errors: updatedErrors,
          };
        });

        // Update verification status
        type === "agent"
          ? setIsPhoneVerified((prev) => ({
              ...prev,
              agentNumVerified: true,
            }))
          : setIsPhoneVerified((prev) => ({
              ...prev,
              buyerNumVerified: true,
            }));

        // Close modal
        setVerificationModalState({
          isOpen: false,
          phoneNumber: "",
          type: null,
        });

        toast.success("Phone number verified successfully");
      } else {
        // Handle failure
        toast.error("Invalid verification code");

        setErrorState((prev) => ({
          ...prev,
          phoneNumber: "Phone number is not verified",
        }));

        type === "agent"
          ? setIsPhoneVerified((prev) => ({
              ...prev,
              agentNumVerified: false,
            }))
          : setIsPhoneVerified((prev) => ({
              ...prev,
              buyerNumVerified: false,
            }));
      }
    } catch (error) {
      console.error("Phone verification failed:", error);
      toast.error("Verification failed. Please try again.");
    } finally {
      setIsCodeVerGoing(false);
    }
  };

  const handlePhoneVerification = async (phoneNumber, type) => {
    try {
      if (!phoneNumber) return;

      const updateError = (isVerified, messgae) => {
        const setError =
          type === "agent" ? setAgentErrorValidate : setErrorValidate;

        type === "agent"
          ? setIsPhoneVerified((prev) => ({
              ...prev,
              buyerNumVerified: true,
              agentNumVerified: isVerified,
            }))
          : setIsPhoneVerified((prev) => ({
              ...prev,
              agentNumVerified: true,
              buyerNumVerified: isVerified,
            }));

        if (isVerified) {
          setError((prev) => {
            const updatedErrors = { ...prev.errors };
            delete updatedErrors["phoneNumber"];
            return {
              isValid: Object.keys(updatedErrors).length === 0,
              errors: updatedErrors,
            };
          });
        } else {
          setError((prev) => ({
            isValid: false,
            errors: {
              ...prev.errors,
              phoneNumber:
                messgae || "We will text you one time verification code",
            },
          }));
        }
        return isVerified;
      };

      setIsPhoneVerGoing(true);
      const isPhoneNumInUse = await isPhoneNoInUse(phoneNumber);

      if (
        !isPhoneNumInUse.data?.data &&
        isPhoneNumInUse.data?.status === "SUCCESS"
      ) {
        const isPhoneVerifiedResult = await isPhoneNoVerified(phoneNumber);
        return updateError(
          isPhoneVerifiedResult.data?.data &&
            isPhoneVerifiedResult.data?.status === "SUCCESS"
        );
      } else {
        const message =
          "This phone number has been already verified for another user. Please use a different number.";
        return updateError(false, message);
      }
    } catch (error) {
      console.log("🚀 ~ handlePhoneVerification ~ error:", error, type);
      const message = "Something went wrong, try again later";

      const setError =
        type === "agent" ? setAgentErrorValidate : setErrorValidate;

      type === "agent"
        ? setIsPhoneVerified((prev) => ({
            ...prev,
            buyerNumVerified: true,
            agentNumVerified: false,
          }))
        : setIsPhoneVerified((prev) => ({
            ...prev,
            agentNumVerified: true,
            buyerNumVerified: false,
          }));

      setError((prev) => ({
        isValid: false,
        errors: {
          ...prev.errors,
          phoneNumber: message,
        },
      }));

      return false;
    } finally {
      setIsPhoneVerGoing(false);
    }
  };

  const handleClickAddButton = async () => {
    // Reset all initial states in a batch
    handleResetAll();

    setBuyerBusinessDocId([]);
    setCoBuyerBusinessDocId([]);
    setBuyerUploadedFiles([]);
    setCoBuyerUploadedFiles([]);

    // Generate a new UUID
    const newTemplateId = uuidv4();
    setTemplateId(newTemplateId);
    setIsNewTemplate(true);

    // Group related state updates together
    setShowAccordianProfile(true);
    setShowAccordian1(true);
    setShowAccordian2(true);
    setShowAccordian3(true);
    setShowAccordian1Body(true);

    // Scroll into view after a slight delay
    setTimeout(() => {
      pageRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

      trackButtonClick({
        eventName: "create_profile_click",
        eventCategory: "my-shopper",
        eventSource: "on plus icon click",
        eventLabel:
          "CWCOT CIF Enabled:false | SRC : Buyer Dashboard My Purchase Profile",
      });
    }, 100);
  };

  const handleCardClick = (data, index) => {
    try {
      handleResetAll();

      setBuyerBusinessDocId([]);
      setCoBuyerBusinessDocId([]);
      setBuyerUploadedFiles([]);
      setCoBuyerUploadedFiles([]);

      setIsNewTemplate(false);
      setShowAccordianProfile(true);
      setIsAccordianDataPreFilled(true);
      setSelectedCardIndex(index);
      setTemplateId(data.templateId);
      setProfileName(data.templateName);

      const isAgent = data?.agentFlag === "Y";
      const isBuyer = data?.agentFlag === "N";

      isAgent
        ? setSelectedDescription("Agent")
        : setSelectedDescription("Buyer");
      const representedByAgent = data.representedByAgent === "Y";
      const agentBuyingForSelf = data.representedByAgent === "N";

      if (isBuyer && representedByAgent) {
        setBuyerRepresentedByAgent("Yes");
        setAgentBuyingForSelf("");
        setIsPhoneVerified({
          buyerNumVerified: false,
          agentNumVerified: true,
          buyerVerificationRequired: true,
          agentVerificationRequired: false,
        });
        handlePhoneVerification(data.buyer.phone, "buyer");
      }

      if (isBuyer && !representedByAgent) {
        setBuyerRepresentedByAgent("No");
        setAgentBuyingForSelf("");
        setIsPhoneVerified({
          buyerNumVerified: false,
          agentNumVerified: true,
          buyerVerificationRequired: true,
          agentVerificationRequired: false,
        });
        handlePhoneVerification(data.buyer.phone, "buyer");
      }

      if (isAgent && agentBuyingForSelf) {
        setBuyerRepresentedByAgent("");
        setAgentBuyingForSelf("Yes");
        setIsPhoneVerified({
          buyerNumVerified: false,
          agentNumVerified: true,
          buyerVerificationRequired: true,
          agentVerificationRequired: false,
        });
        handlePhoneVerification(data.buyer.phone, "agent");
      }

      if (isAgent && !agentBuyingForSelf) {
        setBuyerRepresentedByAgent("");
        setAgentBuyingForSelf("No");
        setIsPhoneVerified({
          buyerNumVerified: true,
          agentNumVerified: false,
          buyerVerificationRequired: false,
          agentVerificationRequired: true,
        });
        handlePhoneVerification(data.agent.phone, "agent");
      }

      trackButtonClick({
        eventName: "purchase_profile_card_select",
        eventCategory: "my-shopper",
        eventLabel: "SRC : Buyer Dashboard My Purchase Profile",
        eventSource: "on existing purchase profile card click",
        eventParams: {
          role: isAgent ? "buyer_agent" : "buyer",
          represented_by_agent: data.representedByAgent,
          display_cwcot_old_cif: true,
        },
      });

      if (data.buyer) {
        setShowAccordian1(true);
        setShowAccordian2(true);
        setAccordian1EditBtnActive(true);
        setAccordian2EditBtnActive(true);
        setAccordian1FormCompleted(true);
        setAccordian2FormCompleted(true);

        getCitiesByState(data.buyer.stateId, "buyer");

        data.buyer?.companyName != null && data.buyer?.companyName !== ""
          ? setIndividual("Business Entity")
          : setIndividual("Individual");

        setBuyerFormData({
          zip: data.buyer.zip || "",
          city: data.buyer.city || "",
          state: data.buyer.stateId || "",
          emailId: data.buyer.email || "",
          phoneNumber: data.buyer.phone || "",
          address1: data.buyer.address1 || "",
          lastName: data.buyer.lastName || "",
          firstName: data.buyer.firstName || "",
          corporationName: data.buyer.companyName || "",
          middleName: data.buyer.middleInitials || "",
        });

        if (data.coBuyer) {
          setHasCoBuyer("Yes");
          getCitiesByState(data.coBuyer.stateId, "coBuyer");
          data.coBuyer?.companyName != null && data.coBuyer?.companyName !== ""
            ? setIndividualCobuyer("BusinessEntityCobuyer")
            : setIndividualCobuyer("IndividualCobuyer");

          setCoBuyerFormData({
            zip: data.coBuyer.zip || "",
            city: data.coBuyer.city || "",
            emailId: data.coBuyer.email || "",
            state: data.coBuyer.stateId || "",
            phoneNumber: data.coBuyer.phone || "",
            address1: data.coBuyer.address1 || "",
            lastName: data.coBuyer.lastName || "",
            firstName: data.coBuyer.firstName || "",
            corporationName: data.coBuyer.companyName || "",
            middleName: data.coBuyer.middleInitials || "",
          });
        }
      }

      // Handle agent information
      if (data.agent) {
        setAccordian3EditBtnActive(true);
        setShowAccordian3(true);
        setAccordian3FormCompleted(true);
        getCitiesByState(data.agent.stateId, "agent");

        setAgentInfo({
          zip: data.agent.zip || "",
          city: data.agent.city || "",
          state: data.agent.stateId || "",
          emailId: data.agent.email || "",
          lastName: data.agent.lastName || "",
          address1: data.agent.address1 || "",
          phoneNumber: data.agent.phone || "",
          firstName: data.agent.firstName || "",
          corporationName: data.agent.companyName || "",
          middleName: data.buyer.middleInitials || "",
          individualLicencenNumber: data.agent.licenceNumber || "",
          corporationState: data.agent.corpLicenceState || "",
          individualLicenceState: data.agent.licenceState || "",
          corporationLicenceNumber: data.agent.corpLicenceNumber || "",
          individualLicenceExpiryDate: convertMMDDYYtoYYYYMMDD(
            data.agent.licenceExpiryDate
          ),
        });
      }

      // Add setTimeout to ensure DOM is updated before scrolling
      setTimeout(async () => {
        if (pageRef.current) {
          pageRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
        const docResult = await fetchPurchaseProfileDocs(data.templateId);
        if (docResult?.data?.buyerLLCFiles) {
          setBuyerUploadedFiles(
            docResult?.data?.buyerLLCFiles.map((item) => item)
          );
          setBuyerBusinessDocId(
            docResult?.data?.buyerLLCFiles.map((item) => item.documentId)
          );
        }
        if (docResult?.data?.coBuyerLLCFiles) {
          setCoBuyerUploadedFiles(
            docResult?.data?.coBuyerLLCFiles.map((item) => item)
          );
          setCoBuyerBusinessDocId(
            docResult?.data?.coBuyerLLCFiles.map((item) => item.documentId)
          );
        }

        trackButtonClick({
          eventName: "update_profile_click",
          eventCategory: "my-shopper",
          eventLabel:
            "CWCOT CIF Enabled:false | SRC : Buyer Dashboard My Purchase Profile",
          eventSource: "on existing purchase profile card click",
        });
      }, 100);
    } catch (error) {
      console.log(
        "🚀 ~ MyPurchaseProfileForm.jsx:839 ~ handleCardClick ~ error:",
        error
      );
    }
  };

  const handleAccordianSubmit = (accordianPosition) => {
    // validate profile name
    if (!profileName.trim()) {
      setProfileError("Profile name is required");
      profileNameRef.current["profileName"]?.focus();
      // Add smooth scroll to the profile name field
      profileNameRef.current["profileName"]?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      return;
    }

    if (profileName.length > 16) {
      setProfileError("Profile name cannot exceed 16 characters");
      return;
    }

    if (profileError !== "") {
      profileNameRef.current["profileName"]?.focus();
      // Add smooth scroll to the profile name field
      profileNameRef.current["profileName"]?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      return;
    }

    switch (accordianPosition) {
      case 1:
        // validate radio buttons
        if (!validateRadioSelections()) {
          return;
        }
        setShowAccordian2(true);
        setShowAccordian1Body(false);
        setAccordian1FormCompleted(true);
        setAccordian2FormCompleted(false);
        setShowAccordian2Body(true);
        setAccordian1EditBtnActive(true);
        setAccordian2EditBtnActive(false);
        !isNewTemplate && setAccordian3EditBtnActive(true);
        // setErrorValidate({})
        // setCoBuyerErrorValidate({})
        // setAgentErrorValidate({})

        setTimeout(() => {
          if (accordian2Ref.current) {
            accordian2Ref.current?.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });

            if (
              selectedDescription === "Agent" &&
              agentBuyingForSelf === "No" &&
              isNewTemplate
            ) {
              if (buyerFormRef.current) {
                buyerFormRef.current["firstName"]?.focus();
              }
            }
          }

          trackButtonClick({
            eventName: "new_cif_wizard_buyer_section_render",
            eventCategory: "my-shopper",
            eventSource: "on accordian 1 submit",
            eventLabel: "SRC : NewBidWizard",
          });
        }, 500);

        break;

      case 2:
        handleValidateForm();
        break;

      case 3:
        handleValidateForm(true);
        break;

      default:
        // Handle other cases if needed
        break;
    }
  };

  const handleValidateForm = async (isAgentSubmit = false) => {
    try {
      setIsFormSubmitLoading(true);
      setShowLicenseTooltip(false);

      // check for early error validation
      if (
        errorValidate.errors &&
        Object.keys(errorValidate.errors).length > 0
      ) {
        const errorFields = Object.keys(errorValidate.errors);
        const documentErrorField = errorFields.find((field) =>
          field.includes("buyerDocumentId")
        );
        const errorField = documentErrorField || errorFields[0];

        if (errorField) {
          if (isAgentSubmit) {
            setShowAccordian2(true);
            setAccordian2FormCompleted(false);
            setShowAccordian2Body(true);
            setAccordian2EditBtnActive(false);
          }

          if (errorField.includes("buyerDocumentId")) {
            setTimeout(() => {
              buyerDocRef.current?.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            }, 500);
          } else {
            setTimeout(() => {
              buyerFormRef.current[errorField]?.focus();
              buyerFormRef.current[errorField]?.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            }, 500);
          }

          setIsFormSubmitLoading(false);
          return;
        }
      }

      if (
        coBuyerErrorValidate.errors &&
        Object.keys(coBuyerErrorValidate.errors).length > 0
      ) {
        const errorFields = Object.keys(coBuyerErrorValidate.errors);
        const documentErrorField = errorFields.find((field) =>
          field.includes("coBuyerDocumentId")
        );
        const errorField = documentErrorField || errorFields[0];

        if (errorField) {
          if (isAgentSubmit) {
            setShowAccordian2(true);
            setAccordian2FormCompleted(false);
            setShowAccordian2Body(true);
            setAccordian2EditBtnActive(false);
          }

          if (errorField.includes("coBuyerDocumentId")) {
            setTimeout(() => {
              coBuyerDocRef.current?.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            }, 500);
          } else {
            setTimeout(() => {
              coBuyerFormRef.current[errorField]?.focus();
              coBuyerFormRef.current[errorField]?.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            }, 500);
          }

          setIsFormSubmitLoading(false);
          return;
        }
      }

      if (
        agentErrorValidate.errors &&
        Object.keys(agentErrorValidate.errors).length > 0
      ) {
        const errorField = Object.keys(agentErrorValidate.errors)[0];

        if (errorField && agentFormRef.current[errorField]) {
          agentFormRef.current[errorField]?.focus();
          agentFormRef.current[errorField]?.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          setIsFormSubmitLoading(false);
          return;
        }
      }

      // Step 0: Validate agent info early if required
      if (isAgentSubmit) {
        const { isValid, errors } = validateAgentForm({
          formData: agentInfo,
          customMessage: true,
        });

        if (!isValid) {
          const errorKeys = Object.keys(errors);

          if (errorKeys.length > 0) {
            const firstErrorKey = errorKeys.find(
              (key) => agentFormRef.current[key]
            );
            if (firstErrorKey && agentFormRef.current[firstErrorKey]) {
              agentFormRef.current[firstErrorKey]?.focus();
              agentFormRef.current[firstErrorKey]?.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            }
          }
          setAgentErrorValidate({
            isValid: false,
            errors: errors,
          });
          setIsFormSubmitLoading(false);
          return;
        }
        setAgentErrorValidate({
          isValid: true,
          errors: {},
        });
      }

      // Step 1: Always validate the primary buyer's form data
      const buyerValidation = validateForm({
        formData: buyerFormData,
        individual: individual,
        customMessage: true,
      });

      const coBuyerValidation =
        hasCobuyer === "Yes"
          ? validateForm({
              formData: coBuyerFormData,
              individual: individualCobuyer,
              customMessage: true,
            })
          : { isValid: true, errors: {} };

      if (!buyerValidation.isValid) {
        const errorKeys = Object.keys(buyerValidation.errors);
        if (errorKeys.length > 0) {
          if (isAgentSubmit) {
            setShowAccordian2(true);
            setAccordian2FormCompleted(false);
            setShowAccordian2Body(true);
            setAccordian2EditBtnActive(false);
          }
          setTimeout(() => {
            const firstErrorKey = errorKeys.find(
              (key) => buyerFormRef.current[key]
            );
            if (firstErrorKey) {
              buyerFormRef.current[firstErrorKey]?.focus();
              buyerFormRef.current[firstErrorKey]?.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            }
          }, 500);
        }
        setErrorValidate({
          isValid: errorKeys.length === 0,
          errors: buyerValidation.errors,
        });
      }
      if (!coBuyerValidation.isValid) {
        const errorKeys = Object.keys(coBuyerValidation.errors);
        if (errorKeys.length > 0) {
          if (isAgentSubmit) {
            setShowAccordian2(true);
            setAccordian2FormCompleted(false);
            setShowAccordian2Body(true);
            setAccordian2EditBtnActive(false);
          }
          setTimeout(() => {
            const firstErrorKey = errorKeys.find(
              (key) => coBuyerFormRef.current[key]
            );

            if (firstErrorKey) {
              coBuyerFormRef.current[firstErrorKey]?.focus();
              coBuyerFormRef.current[firstErrorKey]?.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            }
          }, 500);
        }
        setCoBuyerErrorValidate({
          isValid: errorKeys.length === 0,
          errors: coBuyerValidation.errors,
        });
      }

      if (!buyerValidation.isValid || !coBuyerValidation.isValid) {
        setIsFormSubmitLoading(false);
        return;
      }

      setErrorValidate({
        isValid: true,
        errors: {},
      });
      setCoBuyerErrorValidate({
        isValid: true,
        errors: {},
      });

      // handle validation for doc fields for business entity
      if (individual === "Business Entity") {
        if (buyerBusinessDocId.length === 0) {
          if (isAgentSubmit) {
            setShowAccordian2(true);
            setAccordian2FormCompleted(false);
            setShowAccordian2Body(true);
            setAccordian2EditBtnActive(false);
          }
          setTimeout(() => {
            buyerDocRef.current?.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
            setErrorValidate((prev) => ({
              isValid: false,
              errors: {
                ...prev.errors,
                buyerDocumentId:
                  "Please upload at least one llc document to proceed.",
              },
            }));
          }, 500);
          setIsFormSubmitLoading(false);
          return;
        }
      }

      if (
        hasCobuyer === "Yes" &&
        individualCobuyer === "BusinessEntityCobuyer"
      ) {
        if (coBuyerBusinessDocId.length === 0) {
          if (isAgentSubmit) {
            setShowAccordian2(true);
            setAccordian2FormCompleted(false);
            setShowAccordian2Body(true);
            setAccordian2EditBtnActive(false);
          }
          setTimeout(() => {
            coBuyerDocRef.current?.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
            setCoBuyerErrorValidate((prev) => ({
              isValid: false,
              errors: {
                ...prev.errors,
                coBuyerDocumentId:
                  "Please upload at least one llc document to proceed.",
              },
            }));
          }, 500);
          setIsFormSubmitLoading(false);
          return;
        }
      }

      // Check phone verification status before proceeding
      const verifyPhone = async (phoneNumber, type, formRef) => {
        const digitsOnly = phoneNumber?.replace(/[^\d]/g, "");
        const isVerified = await handlePhoneVerification(digitsOnly, type);
        if (!isVerified) {
          if (
            selectedDescription === "Buyer" &&
            buyerRepresentedByAgent === "Yes" &&
            isAgentSubmit
          ) {
            setShowAccordian2(true);
            setAccordian2FormCompleted(false);
            setShowAccordian2Body(true);
            setAccordian2EditBtnActive(false);
          }
          if (selectedDescription === "Agent" && agentBuyingForSelf === "No") {
            setShowAccordian3(true);
            setAccordian3FormCompleted(false);
            setShowAccordian3Body(true);
            setAccordian3EditBtnActive(false);
          }
          setTimeout(() => {
            formRef.current["phoneNumber"]?.focus();
            formRef.current["phoneNumber"]?.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }, 500);
          setIsFormSubmitLoading(false);
          return false;
        }
        return true;
      };

      // Determine which phone to verify based on user type
      let phoneVerified = true;
      if (selectedDescription === "Buyer") {
        phoneVerified = await verifyPhone(
          buyerFormData.phoneNumber,
          "buyer",
          buyerFormRef
        );
      } else if (selectedDescription === "Agent") {
        const phoneType =
          agentBuyingForSelf === "Yes"
            ? {
                number: buyerFormData.phoneNumber,
                type: "buyer",
                ref: buyerFormRef,
              }
            : {
                number: agentInfo.phoneNumber,
                type: "agent",
                ref: agentFormRef,
              };

        phoneVerified = await verifyPhone(
          phoneType.number,
          phoneType.type,
          phoneType.ref
        );
      }

      if (!phoneVerified) return;

      const errorMap = {
        "Invalid Address": {
          errors: { address1: "Please enter valid address" },
        },
        "Invalid City": {
          errors: { city: "Please enter valid city" },
        },
        "Invalid State": {
          errors: { state: "Please enter valid state" },
        },
        VALIDATION_STATE_ZIP_FAILURE: {
          errors: { zip: "Please enter valid zip" },
        },
      };

      const mapAndSetAddressErrors = (result, setError, type) => {
        const errorMessage = result?.data?.errorMessage;
        const mappedError = errorMap[errorMessage];

        if (mappedError) {
          setError((prev) => ({
            isValid: false,
            errors: {
              ...prev.errors,
              ...mappedError.errors,
            },
          }));

          const errorField = Object.keys(mappedError.errors)[0];

          if (isAgentSubmit && type !== "agent") {
            setShowAccordian2(true);
            setAccordian2FormCompleted(false);
            setShowAccordian2Body(true);
            setAccordian2EditBtnActive(false);
          }

          if (type === "buyer") {
            setTimeout(() => {
              buyerFormRef.current[errorField]?.focus();
              buyerFormRef.current[errorField]?.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            }, 500);
          } else if (type === "co-buyer") {
            setTimeout(() => {
              coBuyerFormRef.current[errorField]?.focus();
              coBuyerFormRef.current[errorField]?.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            }, 500);
          } else {
            setTimeout(() => {
              agentFormRef.current[errorField]?.focus();
              agentFormRef.current[errorField]?.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            }, 500);
          }
          return true;
        }
        setIsFormSubmitLoading(false);
        return false;
      };

      // Step 2: Validate address
      const buyerAddressPayload = {
        address1: buyerFormData.address1,
        city: buyerFormData.city,
        state: buyerFormData.state,
        zip: buyerFormData.zip,
      };

      const buyerAddressResult = await validateAddress(buyerAddressPayload);
      if (
        buyerAddressResult?.data?.status !== "SUCCESS" &&
        mapAndSetAddressErrors(buyerAddressResult, setErrorValidate, "buyer")
      ) {
        setIsFormSubmitLoading(false);
        return;
      }

      if (hasCobuyer === "Yes") {
        const coBuyerAddressPayload = {
          address1: coBuyerFormData.address1,
          city: coBuyerFormData.city,
          state: coBuyerFormData.state,
          zip: coBuyerFormData.zip,
        };
        const coBuyerAddressResult = await validateAddress(
          coBuyerAddressPayload
        );
        if (
          coBuyerAddressResult?.data?.status !== "SUCCESS" &&
          mapAndSetAddressErrors(
            coBuyerAddressResult,
            setCoBuyerErrorValidate,
            "co-buyer"
          )
        ) {
          setIsFormSubmitLoading(false);
          return;
        }
      }

      if (isAgentSubmit) {
        const agentAddressPayload = {
          address1: agentInfo.address1,
          city: agentInfo.city,
          state: agentInfo.state,
          zip: agentInfo.zip,
        };

        const agentAddressResult = await validateAddress(agentAddressPayload);
        if (
          agentAddressResult?.data?.status !== "SUCCESS" &&
          mapAndSetAddressErrors(
            agentAddressResult,
            setAgentErrorValidate,
            "agent"
          )
        ) {
          setIsFormSubmitLoading(false);
          return;
        }
      }

      // Step 3: If agent, verify license and submit
      if (isAgentSubmit) {
        const licensePayload = {
          stateId: agentInfo.state,
          agentEmailId: agentInfo.emailId,
          affiliatedCompany: agentInfo.corporationName,
          agentFirstName: agentInfo.firstName,
          agentLastName: agentInfo.lastName,
          licenceNumber: agentInfo.individualLicencenNumber,
          licenceExpiryDate: formatDisplayDate(
            agentInfo.individualLicenceExpiryDate
          ),
          agentLicenseState: agentInfo.individualLicenceState,
          tempParam: "",
        };

        const licenseResult = await cifVerifyLicenseDetails(licensePayload);
        const status = licenseResult?.data?.verificationStatus;

        const acceptedLicenseStatus = [
          "LICENSE_FORMAT_NOT_ACTIVE",
          "NO_INPUT_DATA",
          "UNKNOWN_STATE_ID",
          "NO_LICENSE_FORMAT_FOUND",
          "LICENSE_RESPONSE_NULL",
          "LICENSE_APPROVED",
          "NO_PATTERN_IN_FORMAT",
          "LICENSE_FORMAT_OK",
          "LICENSE_ALREADY_APPROVED",
        ];

        if (acceptedLicenseStatus.includes(status)) {
          handlePurchaseFinalSubmit();
        } else {
          setIsFormSubmitLoading(false);
          // Show field-specific error if available
          const {
            verificationStatus,
            licenseFormatDescription,
            jurisdictName,
          } = licenseResult?.data || {};

          switch (verificationStatus) {
            case "LICENCE_EXP_DT_INVALID":
            case "INVALID_LICENSE_EXPIRY_DATE":
              setAgentErrorValidate((prev) => ({
                isValid: false,
                errors: {
                  ...prev.errors,
                  individualLicenceExpiryDate: "Invalid License expiry date",
                },
              }));

              // Focus and scroll to the field
              if (agentFormRef.current["individualLicenceExpiryDate"]) {
                agentFormRef.current["individualLicenceExpiryDate"].focus();
                agentFormRef.current[
                  "individualLicenceExpiryDate"
                ].scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
              }
              break;

            case "LICENSE_FORMAT_NOT_OK":
              setShowLicenseTooltip(true);
              setAgentErrorValidate((prev) => ({
                isValid: false,
                errors: {
                  ...prev.errors,
                  individualLicencenNumber:
                    licenseFormatDescription || "Invalid license format",
                },
              }));
              break;

            default:
              // Set the error and focus on the field
              const licenseErrors = {
                INVALID_LICENSE: "Invalid license number",
                LICENSE_FORMAT_NOT_OK: "Invalid license format",
              };
              setAgentErrorValidate((prev) => ({
                isValid: false,
                errors: {
                  ...prev.errors,
                  individualLicencenNumber:
                    licenseFormatDescription ||
                    licenseErrors[verificationStatus] ||
                    "Invalid license number",
                },
              }));

              // Focus and scroll to the field
              if (agentFormRef.current["individualLicencenNumber"]) {
                agentFormRef.current["individualLicencenNumber"].focus();
                agentFormRef.current["individualLicencenNumber"].scrollIntoView(
                  {
                    behavior: "smooth",
                    block: "center",
                  }
                );
              }
              break;
          }
        }

        return;
      }
      // Step 4: Buyer logic
      const isAgentBuyingSelf = agentBuyingForSelf === "Yes";
      const isRepresentedByAgent = buyerRepresentedByAgent === "Yes";
      const isProfileComplete =
        (selectedDescription === "Agent" && isAgentBuyingSelf) ||
        (selectedDescription === "Buyer" && !isRepresentedByAgent);

      if (isProfileComplete) {
        handlePurchaseFinalSubmit();
      } else {
        setIsFormSubmitLoading(false);
        setAccordian1EditBtnActive(true);
        setAccordian2EditBtnActive(true);
        setAccordian3EditBtnActive(false);
        setShowAccordian3(true);
        setShowAccordian3Body(true);
        setAccordian3FormCompleted(false);
        // !isAccordianDataPreFilled && setShowAccordian3Body(true);
        setShowAccordian2Body(false);
        setAccordian2FormCompleted(true);

        setTimeout(() => {
          if (accordian3Ref.current) {
            // First scroll to the accordion
            window.scrollBy(0, -50);

            accordian3Ref.current?.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });

            if (
              selectedDescription === "Buyer" &&
              buyerRepresentedByAgent === "Yes" &&
              isNewTemplate
            ) {
              if (agentFormRef.current) {
                agentFormRef.current["firstName"]?.focus();
              }
            }
          }

          trackButtonClick({
            eventName: "new_cif_wizard_agent_section_render",
            eventCategory: "my-shopper",
            eventSource: "on accordian 2 submit",
            eventLabel: "SRC : NewBidWizard",
          });
        }, 500);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
      setIsFormSubmitLoading(false);
    }
  };

  const handlePurchaseFinalSubmit = async () => {
    setIsFormSubmitLoading(true);

    trackButtonClick({
      eventName: "purchase_profile_save_button_click",
      eventCategory: "my-shopper",
      eventLabel: "Save",
      eventSource: "on create purchase profile click",
    });

    try {
      const isSessionValid = await isValidSession();
      const isValid = isSessionValid.data?.isValidSession;
      if (isValid === "Y") {
        const coBuyer = hasCobuyer === "Yes";
        const isAgent = selectedDescription === "Agent";
        const isBuyer = selectedDescription === "Buyer";
        const isAgentBuyingSelf = agentBuyingForSelf === "Yes";
        const isRepresentedByAgent = buyerRepresentedByAgent === "Yes";

        const digitsOnly = buyerFormData.phoneNumber?.replace(/[^\d]/g, "");

        let payload = {
          agentFlag: isAgent ? "Y" : "N",
          representedByAgent: isBuyer
            ? isRepresentedByAgent
              ? "Y"
              : "N"
            : isAgent
            ? isAgentBuyingSelf
              ? "N"
              : "Y"
            : "N", // Default value if neither condition matches
          buyer: {
            profileName: profileName,
            firstName: buyerFormData.firstName,
            lastName: buyerFormData.lastName,
            companyName: buyerFormData.corporationName,
            middleInitials: buyerFormData.middleName,
            address1: buyerFormData.address1,
            city: buyerFormData.city,
            zip: buyerFormData.zip,
            email: buyerFormData.emailId,
            phone: digitsOnly,
            stateId: buyerFormData.state,
          },
          templateName: profileName,
          templateId: templateId,
          newTemplate: isNewTemplate ? "Y" : "N",
          updateFiles:
            buyerBusinessDocId.length > 0 || coBuyerBusinessDocId.length > 0
              ? "Y"
              : "N",
          userId: user?.user?.realbidUserId,
          isStateWorkflowEnabled: "N",
          isStateWorkflowDurationActive: "N",
          documentIds: [...buyerBusinessDocId, ...coBuyerBusinessDocId],
          variationNumber: "v2",
          propertyStatus: "",
        };

        if (coBuyer) {
          const digitsOnly = coBuyerFormData.phoneNumber?.replace(/[^\d]/g, "");
          payload.coBuyer = {
            firstName: coBuyerFormData.firstName,
            lastName: coBuyerFormData.lastName,
            middleInitials: coBuyerFormData.middleName,
            companyName: coBuyerFormData.corporationName,
            address1: coBuyerFormData.address1,
            stateId: coBuyerFormData.state,
            city: coBuyerFormData.city,
            zip: coBuyerFormData.zip,
            email: coBuyerFormData.emailId,
            phone: digitsOnly,
          };
        }

        if (isRepresentedByAgent || !isAgentBuyingSelf) {
          const digitsOnly = agentInfo.phoneNumber?.replace(/[^\d]/g, "");
          payload.agent = {
            firstName: agentInfo.firstName,
            lastName: agentInfo.lastName,
            middleInitials: agentInfo.middleName,
            companyName: agentInfo.corporationName,
            address1: agentInfo.address1,
            zip: agentInfo.zip,
            stateId: agentInfo.state,
            city: agentInfo.city,
            email: agentInfo.emailId,
            phone: digitsOnly,
            licenceNumber: agentInfo.individualLicencenNumber,
            licenceExpiryDate: formatDisplayDate(
              agentInfo.individualLicenceExpiryDate
            ),
            licenceState: agentInfo.individualLicenceState,
            corpLicenceNumber: agentInfo.corporationLicenceNumber,
            corpLicenceState: agentInfo.corporationState,
          };
        }

        trackButtonClick({
          eventName: "submit_cif_details_api_data",
          eventCategory: "my-shopper",
          eventLabel: `${templateId} | Buyer Category : ${selectedDescription} | CWCOT false`,
          eventSource: "on create purchase profile click",
        });

        const savedResponse = await saveCIFTemplate(payload);
        if (savedResponse.data && savedResponse.data.status === "SUCCESS") {
          trackApiCall({
            eventName: "profile_created",
            eventCategory: "my-shopper",
            eventLabel: `${templateId} | SRC : Buyer Dashboard My Purchase Profile`,
            eventSource: "on create purchase profile click",
          });

          handleResetAll();
          setBuyerBusinessDocId([]);
          setCoBuyerBusinessDocId([]);
          setBuyerUploadedFiles([]);
          setCoBuyerUploadedFiles([]);
          setIsRefresh(true);
          toast.success(
            `Purchase profile ${profileName} ${
              isNewTemplate ? "created" : "updated"
            } successfully`
          );
        } else if (
          savedResponse.data?.errorCode === "DUPLICATE_TEMPLATE_NAME"
        ) {
          toast.error("Template name already exists. Please use another one.");
        } else {
          toast.error("Error while creating the profile");
        }
      } else {
        toast.error("current session not valid, Please login again");
        batch(() => {
          dispatch(setLoginModal(true));
          dispatch(setLoginTab("loginTab"));
          dispatch(setLoginCallLocation("Popup"));
        });
      }
    } catch (error) {
      toast.error("Something went wrong, please try again later");
    } finally {
      setIsFormSubmitLoading(false);
    }
  };

  const handleProfileDelete = async () => {
    trackButtonClick({
      eventName: "delete_conf_yes_click",
      eventCategory: "my-shopper",
      eventLabel: "Close Delete | SRC : Buyer Dashboard My Purchase Profile",
      eventSource: "on delete purchase profile click",
    });

    try {
      setIsDeleting(true);

      const response = await deletePurchaseProfile(templateId);

      if (response.data && response.status === "SUCCESS") {
        trackApiCall({
          eventName: "profile_deleted",
          eventCategory: "my-shopper",
          eventLabel: `${templateId} | SRC : Buyer Dashboard My Purchase Profile`,
          eventSource: "on delete purchase profile click",
        });
        handleResetAll();
        setIsRefresh(true);
        toast.success(`Purchase profile ${profileName} deleted successfully`);
      } else {
        setIsDeleteModalActive(false);
        const errorCode = response.errorCode;
        trackApiCall({
          eventName: "profile_delete_error",
          eventCategory: "my-shopper",
          eventLabel: `${templateId} | SRC : Buyer Dashboard My Purchase Profile`,
          eventSource: "on delete purchase profile click failure",
        });
        if (errorCode === "UNABLE_TO_DELETE_ACTIVE_BID_EXIST") {
          toast.error(
            "This purchase cannot be deleted currently as it was recently used for a property."
          );
        } else {
          toast.error("Error while deleting the profile");
        }
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    } finally {
      setIsDeleting(false);
    }
  };

  const handleResetAll = () => {
    setIsLoading(false);
    setIsDeleting(false);
    setIsFormSubmitLoading(false);
    setIsDeleteModalActive(false);
    setSelectedCardIndex(null);
    setIsNewTemplate(null);
    setShowAccordian1(false);
    setShowAccordian2(false);
    setShowAccordian3(false);
    setShowAccordian1Body(false);
    setShowAccordian2Body(false);
    setShowAccordian3Body(false);
    setAccordian1FormCompleted(false);
    setAccordian2FormCompleted(false);
    setAccordian3FormCompleted(false);
    setIsAccordianDataPreFilled(false);
    setAccordian1EditBtnActive(false);
    setAccordian2EditBtnActive(false);
    setAccordian3EditBtnActive(false);
    setShowAccordianProfile(false);
    setShowLicenseTooltip(false);
    setApiError(null);
    setProfileError("");
    setFormErrors({});
    setErrorValidate({
      isValid: true,
      errors: {},
    });
    setAgentErrorValidate({
      isValid: true,
      errors: {},
    });
    setCoBuyerErrorValidate({
      isValid: true,
      errors: {},
    });
    setTemplateId(null);
    setProfileName("");
    setAgentBuyingForSelf("");
    setSelectedDescription("");
    setHasCoBuyer("No");
    setIndividual("Individual");
    setIndividualCobuyer("IndividualCobuyer");
    setBuyerRepresentedByAgent("");

    setLocationData({
      buyer: {
        state: null,
        cities: [],
        loaded: false,
      },
      coBuyer: {
        state: null,
        cities: [],
        loaded: false,
      },
      agent: {
        state: null,
        cities: [],
        loaded: false,
      },
    });

    setBuyerFormData({
      firstName: "",
      lastName: "",
      middleName: "",
      corporationName: "",
      address1: "",
      city: "",
      zip: "",
      emailId: "",
      phoneNumber: "",
      state: "",
    });
    setCoBuyerFormData({
      firstName: "",
      lastName: "",
      middleName: "",
      corporationName: "",
      address1: "",
      city: "",
      zip: "",
      emailId: "",
      phoneNumber: "",
      state: "",
    });
    setAgentInfo({
      firstName: "",
      lastName: "",
      middleName: "",
      corporationName: "",
      address1: "",
      zip: "",
      city: "",
      emailId: "",
      phoneNumber: "",
      individualLicencenNumber: "",
      individualLicenceExpiryDate: "",
      individualLicenceState: "",
      corporationLicenceNumber: "",
      corporationState: "",
    });
    setIsPhoneVerified({
      buyerNumVerified: true,
      agentNumVerified: true,
      buyerVerificationRequired: false,
      agentVerificationRequired: false,
    });
    setVerificationModalState({
      isOpen: false,
      phoneNumber: "",
      type: null,
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    let isMounted = true;
    setIsRefresh(false);
    // Track if component is mounted to prevent state updates after unmount

    setIsLoading(true);
    setApiError(null);

    // Run all api calls in parallel
    Promise.all([
      fetchUserProfile(),
      getPurchaseProfileCMS("pages/userDashboard"),
      getPurchaseProfileByUserId(),
    ])
      .then(([profileResult, cmsResult, purchaseProfileResult]) => {
        // only update state if component is still mounted
        if (isMounted) {
          // Set CMS data
          const cmsProfileData =
            cmsResult?.results[0]?.dashboard?.dashboardMenus?.myPurchaseProfile;
          setCmsData(cmsProfileData);
          // set user profile data
          setPurchaseProfileUser(purchaseProfileResult?.data?.data);
          setIsLoading(false);

          trackApiCall({
            eventName: "render_cif",
            eventCategory: "my-shopper",
            eventLabel:
              "CWCOT CIF Enabled:false | SRC :Buyer Dashboard My Purchase Profile",
          });
        }
      })
      .catch((error) => {
        if (isMounted) {
          console.error("Error fetching data:", error);
          setApiError(
            error?.message || "Failed to load profile data. Please try again."
          );
          setIsLoading(false);
        }
      });

    // Cleanup function
    return () => {
      isMounted = false;
    };
  }, [isRefresh]);

  const getCitiesByState = async (state, type) => {
    try {
      if (!state) return;

      const response = await cityList(state);
      const cityOptions = response.data.data.map((city) => ({
        value: city,
        label: city,
      }));

      setLocationData((prev) => ({
        ...prev,
        [type]: {
          ...prev[type],
          cities: cityOptions,
          state: state,
          loaded: true,
        },
      }));
    } catch (error) {
      console.log(
        "🚀 ~ MyPurchaseProfileForm.jsx:1601 ~ getCitiesByState ~ error:",
        error
      );
    }
  };

  useEffect(() => {
    if (
      buyerFormData.state &&
      buyerFormData.state !== locationData.buyer.state
    ) {
      getCitiesByState(buyerFormData.state, "buyer");
    }
    if (
      coBuyerFormData.state &&
      coBuyerFormData.state !== locationData.coBuyer.state
    ) {
      getCitiesByState(coBuyerFormData.state, "coBuyer");
    }
    if (agentInfo.state && agentInfo.state !== locationData.agent.state) {
      getCitiesByState(agentInfo.state, "agent");
    }
  }, [buyerFormData.state, coBuyerFormData.state, agentInfo.state]);

  const CheckIcon = ({ isActive }) => (
    <span
      className="fa fa-check-circle p-icon"
      style={{ color: isActive ? "green" : "black" }}
    />
  );

  const TextDisplay = ({
    label,
    value,
    className = "panel-section-child1",
  }) => (
    <div className={className}>
      <div className="panel-section-text-left">{label}</div>
      <div className="panel-section-text-right">{value}</div>
    </div>
  );

  const PersonInfo = ({ type, person }) =>
    person && (
      <div className="pp-child-container">
        <div className="p-label">{type}:</div>
        <div className="p-value">
          {person.firstName} {person.lastName}
        </div>
      </div>
    );

  return (
    <div className="">
      <DeletePopupModal
        title="Delete Profile"
        subtitle="Are you sure you want to delete the Profile?"
        isLoading={isDeleting}
        isOpen={isDeleteModalActive}
        onClose={() => {
          setIsDeleteModalActive(false);
          trackButtonClick({
            eventName: "delete_conf_no_click",
            eventCategory: "my-shopper",
            eventLabel:
              "Close Delete | SRC : Buyer Dashboard My Purchase Profile",
            eventSource: "on delete purchase profile click",
          });
        }}
        onConfirm={handleProfileDelete}
      />

      <PhoneVerificationModal
        isOpen={verificationModalState.isOpen}
        onClose={() =>
          setVerificationModalState({
            isOpen: false,
            phoneNumber: "",
            type: null,
          })
        }
        onVerify={handleVerifyPhone}
        phoneNumber={verificationModalState.phoneNumber}
        isLoading={isCodeVerGoing}
      />

      <Container className="pb-4">
        {isLoading ? (
          <div className="text-center my-3">
            <ShimmerSimpleGallery imageHeight={200} />
          </div>
        ) : apiError ? (
          <div className="alert alert-danger" role="alert">
            {apiError}
          </div>
        ) : (
          <Row className="">
            <Col xs={12} md={4} className="g-4">
              <Card
                className={`purchase-profile-cards h-100 text-center ${
                  isNewTemplate ? "pp-disabled-card" : ""
                }`}
                onClick={isNewTemplate ? null : handleClickAddButton}
              >
                <Card.Body className="pp-add-new-container" tabIndex="0">
                  <div
                    className={`add-profile-icon ${
                      isNewTemplate ? "add-profile-icon-dis" : ""
                    }`}
                  >
                    +
                  </div>
                  <div
                    className={`add-profile-label ${
                      isNewTemplate ? "add-profile-label-dis" : ""
                    }`}
                  >
                    Add New Profile
                  </div>
                </Card.Body>
              </Card>
            </Col>

            {purchaseProfileUser &&
              purchaseProfileUser.map((data, index) => (
                // <Col xs={12} md={4}>
                <Col xs={12} md={4} className="g-4">
                  <Card
                    className={`h-100 purchase-profile-cards ${
                      selectedCardIndex === index ? "p-selected-card" : ""
                    }`}
                    tabIndex="0"
                    onClick={() => handleCardClick(data, index)}
                  >
                    <Card.Header className="p-name">
                      <div className="p-icon-container">
                        {selectedCardIndex === index && (
                          <CheckIcon isActive={true} />
                        )}
                        <span>{data.templateName}</span>
                      </div>
                      {selectedCardIndex !== index && (
                        <span
                          className="fa fa-pencil-square-o"
                          style={{ color: "#fff", fontSize: 24 }}
                        />
                      )}
                    </Card.Header>
                    <Card.Body className="purchase-profile-card-body">
                      <div className="flex-grow-1">
                        <PersonInfo type="Buyer" person={data.buyer} />
                        <PersonInfo type="Cobuyer" person={data.coBuyer} />
                        <PersonInfo type="Agent" person={data.agent} />
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
          </Row>
        )}
      </Container>

      <Row ref={pageRef}>
        {/* save time and bid faster with purhcase profile name */}
        {showAccordianProfile && (
          <Container className="purchase-profile-heading-container">
            <div className="pp-heading-child-container">
              {isNewTemplate && (
                <>
                  <Row>
                    <Col>
                      <div className="form-header purchase-profile-heading">
                        Save Time, Bid Faster!
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="purchase-profile-sub-heading">
                        Use the information on this buyer information form to
                        create a divurchase profile. Using purchase profile will
                        make bidding on another property easier and faster.
                      </div>
                    </Col>
                  </Row>
                </>
              )}
              <div className="purchase-profile-name-container">
                <Form className="w-80">
                  <Form.Group
                    as={Row}
                    className="mb-3 align-items-center"
                    controlId="formPurchaseProfileName"
                  >
                    <Col xs="12" sm="6">
                      <Form.Label column className="pp-profile-label">
                        Purchase Profile Name
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder=""
                        maxLength="16"
                        required
                        name="profileName"
                        value={profileName}
                        onBlur={handleCheckProfileName}
                        onChange={handleProfileNameChange}
                        isInvalid={!!profileError}
                        ref={(el) =>
                          (profileNameRef.current["profileName"] = el)
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {profileError}
                      </Form.Control.Feedback>
                    </Col>
                    <Col xs="12" sm="6" className="mt-4">
                      <span>Character limit: {profileName.length}/16</span>
                    </Col>
                  </Form.Group>
                </Form>

                {!isNewTemplate && (
                  <div className="d-none d-md-block">
                    <button
                      className="purchase-profile-delete-btn"
                      onClick={() => {
                        setIsDeleteModalActive(true);
                        trackButtonClick({
                          eventName: "delete_clicked",
                          eventCategory: "my-shopper",
                          eventLabel:
                            "SRC : Buyer Dashboard My Purchase Profile",
                          eventSource: "on delete purchase profile click",
                        });
                      }}
                    >
                      Delete Profile
                    </button>
                  </div>
                )}
              </div>
            </div>
          </Container>
        )}

        {/* rest 3 accordians  */}
        <Container className="p-0 m-0">
          <div className="accordion accordion-flush" id="accordionFlushExample">
            {/* THIS IS THE FIRST ACCORDIAN */}
            {showAccordian1 && (
              <div className="accordion-item" ref={accordian1Ref}>
                <div className="purchase-prof-accordion-header accordion-header-responsive">
                  <div className="d-flex align-items-center">
                    {accordian1EditBtnActive && accordian1FormCompleted ? (
                      <CheckIcon isActive={true} />
                    ) : (
                      <CheckIcon isActive={false} />
                    )}
                    <span className="panel-title">
                      Buyer/ Agent Information
                    </span>
                  </div>

                  {isAccordianDataPreFilled && !showAccordian1Body && (
                    <span className="panel-subTxt ">
                      Information has been pre-filled with the selected purchase
                      profile.
                    </span>
                  )}

                  {accordian1EditBtnActive && (
                    <div
                      className="panel-edit-btn"
                      onClick={() => {
                        setShowAccordian1Body(true);
                        setAccordian1FormCompleted(false);
                        setAccordian1EditBtnActive(false);

                        setShowAccordian2Body(false);
                        setAccordian2EditBtnActive(true);
                        setAccordian2FormCompleted(true);

                        if (!isNewTemplate && showAccordian3) {
                          setShowAccordian3Body(false);
                          setAccordian3EditBtnActive(true);
                          setAccordian3FormCompleted(true);
                        }

                        if (isNewTemplate && showAccordian3) {
                          setAccordian3FormCompleted(false);
                        }
                      }}
                    >
                      Edit
                    </div>
                  )}
                </div>

                {showAccordian1Body && (
                  <div className="accordion-body">
                    <Form>
                      <div className="p-0 p-md-4">
                        <Form.Group as={Row} className="mb-4">
                          <Col sm="12">
                            <Form.Label>
                              What describes you best?
                              <span style={{ color: "red" }}>*</span>
                            </Form.Label>
                          </Col>
                          <Col sm="12">
                            <div className="d-flex">
                              <Form.Check
                                type="radio"
                                label="Buyer"
                                name="bestDescription"
                                value="Buyer"
                                required
                                className="me-3"
                                onChange={handleDescriptionChange}
                                checked={selectedDescription === "Buyer"}
                              />
                              <Form.Check
                                type="radio"
                                label="Agent"
                                name="bestDescription"
                                value="Agent"
                                required
                                onChange={handleDescriptionChange}
                                checked={selectedDescription === "Agent"}
                              />
                            </div>
                            {formErrors.description && (
                              <div className="text-danger mt-1">
                                {formErrors.description}
                              </div>
                            )}
                          </Col>
                        </Form.Group>

                        <Form.Group as={Row}>
                          <Col sm="12">
                            <Form.Label>
                              {selectedDescription === "Buyer"
                                ? "Are you represented by an Agent?"
                                : "Are you buying this property for yourself?"}
                              <span style={{ color: "red" }}>*</span>
                            </Form.Label>
                          </Col>
                          <Col sm="12">
                            <div className="d-flex">
                              <Form.Check
                                type="radio"
                                label="Yes"
                                value="Yes"
                                required
                                className="me-3"
                                onChange={handleBuyingForSelfChange}
                                checked={
                                  selectedDescription === "Buyer"
                                    ? buyerRepresentedByAgent === "Yes"
                                    : agentBuyingForSelf === "Yes"
                                }
                              />
                              <Form.Check
                                type="radio"
                                label="No"
                                value="No"
                                required
                                onChange={handleBuyingForSelfChange}
                                checked={
                                  selectedDescription === "Buyer"
                                    ? buyerRepresentedByAgent === "No"
                                    : agentBuyingForSelf === "No"
                                }
                              />
                            </div>
                            {!selectedDescription && (
                              <div className="text-danger mt-1">
                                {formErrors.buyerRepresentedByAgent}
                              </div>
                            )}

                            {selectedDescription === "Buyer" &&
                              formErrors.buyerRepresentedByAgent && (
                                <div className="text-danger mt-1">
                                  {formErrors.buyerRepresentedByAgent}
                                </div>
                              )}
                            {selectedDescription === "Agent" &&
                              formErrors.agentBuyingForSelf && (
                                <div className="text-danger mt-1">
                                  {formErrors.agentBuyingForSelf}
                                </div>
                              )}
                          </Col>
                        </Form.Group>
                      </div>

                      {selectedDescription === "Buyer" &&
                        buyerRepresentedByAgent === "No" && (
                          <PurchaseProfileBuyerAgentDesc data={cmsData} />
                        )}

                      {selectedDescription === "Agent" &&
                        agentBuyingForSelf === "Yes" && (
                          <PurchaseProfileBuyerAgentDesc data={cmsData} />
                        )}

                      <Button
                        className="purchase-prof-continue-btn"
                        onClick={() => handleAccordianSubmit(1)}
                      >
                        Continue
                      </Button>
                    </Form>
                  </div>
                )}

                {accordian1FormCompleted && (
                  <div className="panel-section-head">
                    <TextDisplay
                      label="What describes you best? :"
                      value={selectedDescription}
                      className="panel-section-child1"
                    />

                    <TextDisplay
                      label={
                        selectedDescription === "Buyer"
                          ? "Represented by an Agent? :"
                          : "Buying this property for your self? :"
                      }
                      value={
                        selectedDescription === "Buyer"
                          ? buyerRepresentedByAgent
                          : agentBuyingForSelf
                      }
                      className="panel-section-child2"
                    />
                  </div>
                )}
              </div>
            )}

            {/* THIS IS THE SECOND ACCORDIAN */}
            {showAccordian2 && (
              <div className="accordion-item" ref={accordian2Ref}>
                <div className="purchase-prof-accordion-header accordion-header-responsive">
                  <div className="d-flex align-items-center">
                    {accordian2EditBtnActive && accordian2FormCompleted ? (
                      <CheckIcon isActive={true} />
                    ) : (
                      <CheckIcon isActive={false} />
                    )}
                    <span className="panel-title">Buyer's Information</span>
                  </div>

                  {isAccordianDataPreFilled && !showAccordian2Body && (
                    <span className="panel-subTxt">
                      Information has been pre-filled with the selected purchase
                      profile.
                    </span>
                  )}

                  {accordian2EditBtnActive && (
                    <div
                      className="panel-edit-btn"
                      onClick={() => {
                        setShowAccordian2Body(true);
                        setAccordian2EditBtnActive(false);
                        setAccordian2FormCompleted(false);

                        setShowAccordian1Body(false);
                        setAccordian1EditBtnActive(true);
                        setAccordian1FormCompleted(true);

                        isNewTemplate &&
                          showAccordian3 &&
                          setShowAccordian3Body(false);

                        if (!isNewTemplate && showAccordian3) {
                          setShowAccordian3Body(false);
                          setAccordian3EditBtnActive(true);
                          setAccordian3FormCompleted(true);
                        }
                      }}
                    >
                      Edit
                    </div>
                  )}
                </div>

                {showAccordian2Body && (
                  <div className="accordion-body">
                    <p
                      className="pannel-accordian2-para custom-col-padding"
                      style={{ paddingLeft: 24 }}
                    >
                      As this profile information will be used to bind legal
                      contract, please ensure to add information correctly.
                      Missing information and/or inaccurate information can
                      cause the contract to be rejected.
                    </p>
                    <div className="p-0 p-md-4">
                      <Form>
                        <Form.Group as={Row} className="mb-3">
                          <Col sm="12 mt-4">
                            <Form.Label
                              style={{ color: "#383B42" }}
                              className="pp-responsive-font"
                            >
                              Purchase is being made on behalf of:
                              <span style={{ color: "red" }}>*</span>
                            </Form.Label>
                          </Col>
                          <Col sm="12">
                            <div className="d-flex align-items-center">
                              <Form.Check
                                type="radio"
                                label="Individual"
                                name="Individual"
                                id="individualRadio"
                                value="Individual"
                                checked={individual === "Individual"}
                                required
                                style={{ marginRight: "1.5rem" }}
                                onChange={handleIndividualChange}
                                className="pp-responsive-font"
                              />
                              <Form.Check
                                type="radio"
                                label="Business Entity"
                                name="Individual"
                                id="businessRadio"
                                value="Business Entity"
                                checked={individual === "Business Entity"}
                                required
                                onChange={handleIndividualChange}
                                className="pp-responsive-font"
                              />
                            </div>
                            <Form>
                              {individual === "Individual" ? (
                                <Row>
                                  {individualEntityField.map((item, index) => (
                                    <Col
                                      md={6}
                                      xs={12}
                                      key={index}
                                      className="g-4"
                                    >
                                      <label
                                        htmlFor={item.placeholder}
                                        className="form-label pp-form-label"
                                      >
                                        {item.label}
                                        {item.required && (
                                          <span className="text-danger">*</span>
                                        )}
                                      </label>
                                      {item.type === "dropdown" ? (
                                        <Form.Select
                                          ref={(el) =>
                                            (buyerFormRef.current[
                                              item.formValueLabel
                                            ] = el)
                                          }
                                          className="form-select pp-select-field"
                                          id={item.placeholder}
                                          value={
                                            buyerFormData[
                                              item.formValueLabel
                                            ] || ""
                                          }
                                          name={item.formValueLabel}
                                          required={item.required}
                                          onChange={handleBuyerFieldChange}
                                          style={{
                                            padding: "12px",
                                          }}
                                        >
                                          <option value="">
                                            {item.placeholder}
                                          </option>

                                          {item.formValueLabel === "state"
                                            ? (stateList || []).map(
                                                (option) => (
                                                  <option
                                                    key={option}
                                                    value={option}
                                                  >
                                                    {option}
                                                  </option>
                                                )
                                              )
                                            : null}
                                        </Form.Select>
                                      ) : item.formValueLabel === "city" ? (
                                        <SuggestionInput
                                          inputRef={(el) =>
                                            (buyerFormRef.current[
                                              item.formValueLabel
                                            ] = el)
                                          }
                                          type={item.type}
                                          formType="buyer"
                                          id={item.placeholder}
                                          setError={setErrorValidate}
                                          placeholder={item.placeholder}
                                          className="form-control pp-input-field"
                                          value={
                                            buyerFormData[
                                              item.formValueLabel
                                            ] || ""
                                          }
                                          onChange={handleBuyerFieldChange}
                                          name={item.formValueLabel}
                                          required={item.required}
                                          cityLoaded={locationData.buyer.loaded}
                                          suggestions={
                                            locationData.buyer.cities || []
                                          }
                                        />
                                      ) : item.formValueLabel ===
                                          "phoneNumber" &&
                                        isPhoneVerified.buyerVerificationRequired ? (
                                        <PhoneInputField
                                          item={item}
                                          formRef={(el) =>
                                            (buyerFormRef.current[
                                              item.formValueLabel
                                            ] = el)
                                          }
                                          value={
                                            buyerFormData[item.formValueLabel]
                                          }
                                          id={item.placeholder}
                                          onChange={handleBuyerFieldChange}
                                          onBlur={handleBuyerFieldChange}
                                          type={item.type}
                                          isVerified={
                                            isPhoneVerified.buyerNumVerified
                                          }
                                          setShowVerifyModal={() =>
                                            setVerificationModalState({
                                              isOpen: true,
                                              phoneNumber:
                                                buyerFormData.phoneNumber,
                                              type: "buyer",
                                            })
                                          }
                                        />
                                      ) : (
                                        <Form.Control
                                          ref={(el) =>
                                            (buyerFormRef.current[
                                              item.formValueLabel
                                            ] = el)
                                          }
                                          type={item.type}
                                          id={item.placeholder}
                                          maxLength={item.maxLength}
                                          placeholder={item.placeholder}
                                          className="form-control pp-input-field"
                                          readOnly={
                                            item.type === "email" &&
                                            (selectedDescription === "Buyer" ||
                                              (selectedDescription ===
                                                "Agent" &&
                                                agentBuyingForSelf === "Yes"))
                                          }
                                          value={
                                            item.formValueLabel ===
                                            "phoneNumber"
                                              ? formatPhoneNumber(
                                                  buyerFormData[
                                                    item.formValueLabel
                                                  ]
                                                )
                                              : buyerFormData[
                                                  item.formValueLabel
                                                ] || ""
                                          }
                                          onChange={handleBuyerFieldChange}
                                          onBlur={handleBuyerFieldChange}
                                          name={item.formValueLabel}
                                          required={item.required}
                                        />
                                      )}

                                      {errorValidate.errors &&
                                        errorValidate.errors[
                                          item.formValueLabel
                                        ] && (
                                          <div
                                            className={
                                              errorValidate.errors[
                                                item.formValueLabel
                                              ].includes(
                                                "We will text you one time verification code"
                                              )
                                                ? "pp-error-message text-secondary"
                                                : "pp-error-message"
                                            }
                                          >
                                            {
                                              errorValidate.errors[
                                                item.formValueLabel
                                              ]
                                            }
                                          </div>
                                        )}
                                    </Col>
                                  ))}
                                </Row>
                              ) : (
                                <Row>
                                  {businessEntityField.map((item, index) => (
                                    <Col
                                      md={item.type === "file" ? 12 : 6}
                                      xs={12}
                                      key={index}
                                      className="g-4"
                                    >
                                      {item.type !== "file" && (
                                        <label
                                          htmlFor={item.placeholder}
                                          className="form-label pp-form-label"
                                        >
                                          {item.label}
                                          {item.required && (
                                            <span className="text-danger">
                                              *
                                            </span>
                                          )}
                                        </label>
                                      )}

                                      {item.type === "dropdown" ? (
                                        <Form.Select
                                          ref={(el) =>
                                            (buyerFormRef.current[
                                              item.formValueLabel
                                            ] = el)
                                          }
                                          className="form-select pp-dropdown"
                                          value={
                                            buyerFormData[
                                              item.formValueLabel
                                            ] || ""
                                          }
                                          name={item.formValueLabel}
                                          id={item.placeholder}
                                          required={item.required}
                                          onChange={handleBuyerFieldChange}
                                          style={{
                                            padding: "12px",
                                          }}
                                        >
                                          <option value="">
                                            {item.placeholder}
                                          </option>

                                          {item.formValueLabel === "state"
                                            ? // Render state options
                                              (stateList || []).map(
                                                (option) => (
                                                  <option
                                                    key={option}
                                                    value={option}
                                                  >
                                                    {option}
                                                  </option>
                                                )
                                              )
                                            : null}
                                        </Form.Select>
                                      ) : item.type === "file" ? (
                                        <DocumentUpload
                                          isCoBuyer={false}
                                          docRef={buyerDocRef}
                                          setDocumentId={setBuyerBusinessDocId}
                                          templateId={templateId}
                                          buyerType={"LLC-buyer"}
                                          uploadedFiles={buyerUploadedFiles}
                                          setUploadedFiles={
                                            setBuyerUploadedFiles
                                          }
                                          setErrorValidate={setErrorValidate}
                                        />
                                      ) : item.formValueLabel === "city" ? (
                                        <SuggestionInput
                                          inputRef={(el) =>
                                            (buyerFormRef.current[
                                              item.formValueLabel
                                            ] = el)
                                          }
                                          type={item.type}
                                          formType="buyer"
                                          id={item.placeholder}
                                          setError={setErrorValidate}
                                          placeholder={item.placeholder}
                                          className="form-control pp-input-field"
                                          value={
                                            buyerFormData[
                                              item.formValueLabel
                                            ] || ""
                                          }
                                          onChange={handleBuyerFieldChange}
                                          name={item.formValueLabel}
                                          required={item.required}
                                          cityLoaded={locationData.buyer.loaded}
                                          suggestions={
                                            locationData.buyer.cities || []
                                          }
                                        />
                                      ) : item.formValueLabel ===
                                          "phoneNumber" &&
                                        isPhoneVerified.buyerVerificationRequired ? (
                                        <PhoneInputField
                                          item={item}
                                          formRef={(el) =>
                                            (buyerFormRef.current[
                                              item.formValueLabel
                                            ] = el)
                                          }
                                          value={
                                            buyerFormData[item.formValueLabel]
                                          }
                                          onChange={handleBuyerFieldChange}
                                          id="myphone"
                                          onBlur={handleBuyerFieldChange}
                                          type={item.type}
                                          isVerified={
                                            isPhoneVerified.buyerNumVerified
                                          }
                                          setShowVerifyModal={() =>
                                            setVerificationModalState({
                                              isOpen: true,
                                              phoneNumber:
                                                buyerFormData.phoneNumber,
                                              type: "buyer",
                                            })
                                          }
                                        />
                                      ) : (
                                        <Form.Control
                                          ref={(el) =>
                                            (buyerFormRef.current[
                                              item.formValueLabel
                                            ] = el)
                                          }
                                          type={item.type}
                                          maxLength={item.maxLength}
                                          id={item.placeholder}
                                          className="form-control pp-input-field"
                                          placeholder={item.placeholder}
                                          readOnly={
                                            item.type === "email" &&
                                            (selectedDescription === "Buyer" ||
                                              (selectedDescription ===
                                                "Agent" &&
                                                agentBuyingForSelf === "Yes"))
                                          }
                                          value={
                                            item.formValueLabel ===
                                            "phoneNumber"
                                              ? formatPhoneNumber(
                                                  buyerFormData[
                                                    item.formValueLabel
                                                  ]
                                                )
                                              : buyerFormData[
                                                  item.formValueLabel
                                                ] || ""
                                          }
                                          onChange={handleBuyerFieldChange}
                                          onBlur={handleBuyerFieldChange}
                                          name={item.formValueLabel}
                                          required={item.required}
                                        />
                                      )}

                                      {item.formValueLabel === "documentId"
                                        ? errorValidate.errors[
                                            "buyerDocumentId"
                                          ] && (
                                            <div className={"pp-error-message"}>
                                              {
                                                errorValidate.errors[
                                                  "buyerDocumentId"
                                                ]
                                              }
                                            </div>
                                          )
                                        : errorValidate.errors[
                                            item.formValueLabel
                                          ] && (
                                            <div
                                              className={
                                                errorValidate.errors[
                                                  item.formValueLabel
                                                ].includes(
                                                  "We will text you one time verification code"
                                                )
                                                  ? "pp-error-message text-secondary"
                                                  : "pp-error-message"
                                              }
                                            >
                                              {
                                                errorValidate.errors[
                                                  item.formValueLabel
                                                ]
                                              }
                                            </div>
                                          )}
                                    </Col>
                                  ))}
                                </Row>
                              )}

                              <Form.Group as={Row} className="my-4">
                                <Col sm="12">
                                  <Form.Label className="pp-responsive-font">
                                    Do you have a co-buyer?
                                  </Form.Label>
                                </Col>
                                <Col sm="12">
                                  <div className="d-flex">
                                    <Form.Check
                                      type="radio"
                                      label="Yes"
                                      id="coBuyerYes"
                                      name="coBuyer"
                                      value="Yes"
                                      onChange={handleCoBuyerChange}
                                      checked={hasCobuyer === "Yes"}
                                      required
                                      className="me-3 pp-responsive-font"
                                    />
                                    <Form.Check
                                      type="radio"
                                      label="No"
                                      name="coBuyer"
                                      id="coBuyerNo"
                                      value="No"
                                      onChange={handleCoBuyerChange}
                                      checked={hasCobuyer === "No"}
                                      required
                                      className="pp-responsive-font"
                                    />
                                  </div>
                                </Col>
                              </Form.Group>
                              {hasCobuyer === "Yes" && (
                                <PurchaseProfileIndividualBusinessEntity
                                  state={stateList}
                                  data={cmsData}
                                  locationData={locationData}
                                  coBuyerDocRef={coBuyerDocRef}
                                  templateId={templateId}
                                  coBuyerFormRef={coBuyerFormRef}
                                  uploadedFiles={coBuyerUploadedFiles}
                                  setDocumentsId={setCoBuyerBusinessDocId}
                                  setUploadedFiles={setCoBuyerUploadedFiles}
                                  coBuyerFormData={coBuyerFormData}
                                  setCoBuyerFormData={setCoBuyerFormData}
                                  handleCoBuyerFieldChange={
                                    handleCoBuyerFieldChange
                                  }
                                  coBuyerErrorValidate={
                                    coBuyerErrorValidate.errors
                                  }
                                  setCoBuyerErrorValidate={
                                    setCoBuyerErrorValidate
                                  }
                                  IndividualCobuyer={individualCobuyer}
                                  setIndividualCobuyer={setIndividualCobuyer}
                                />
                              )}
                              <Button
                                className="purchase-prof-continue-btn"
                                onClick={() => handleAccordianSubmit(2)}
                              >
                                {isFormSubmitLoading ? (
                                  <LoadingText text={`Verifying...`} />
                                ) : (
                                  <LoadedText
                                    text={
                                      isNewTemplate
                                        ? (selectedDescription === "Buyer" &&
                                            buyerRepresentedByAgent === "No") ||
                                          (selectedDescription === "Agent" &&
                                            agentBuyingForSelf === "Yes")
                                          ? "Create"
                                          : "Continue"
                                        : (selectedDescription === "Buyer" &&
                                            buyerRepresentedByAgent === "No") ||
                                          (selectedDescription === "Agent" &&
                                            agentBuyingForSelf === "Yes")
                                        ? "Update"
                                        : "Continue"
                                    }
                                  />
                                )}
                              </Button>
                            </Form>
                          </Col>
                        </Form.Group>
                      </Form>
                    </div>
                  </div>
                )}

                {accordian2FormCompleted && (
                  <div className="panel-section-head">
                    <div className="closed-view-main-title">
                      Buyer's information on legal document will be:{" "}
                    </div>
                    <div className="pannel-section-container">
                      {buyerFormData.firstName && (
                        <div className="pannel-section-left-container">
                          <div className="closed-view-sub-title">Buyer</div>
                          <TextDisplay
                            label="Name :"
                            value={
                              buyerFormData.firstName +
                              " " +
                              buyerFormData.lastName
                            }
                            className="panel-section-child1"
                          />
                          <TextDisplay
                            label="Email :"
                            value={buyerFormData.emailId}
                            className="panel-section-child1"
                          />
                          {buyerFormData.corporationName && (
                            <TextDisplay
                              label="Corporation Name :"
                              value={buyerFormData.corporationName}
                              className="panel-section-child1"
                            />
                          )}
                        </div>
                      )}
                      {coBuyerFormData.firstName && (
                        <div className="pannel-section-right-container">
                          <div className="closed-view-sub-title">Co-Buyer</div>
                          <TextDisplay
                            label="Name :"
                            value={coBuyerFormData.firstName}
                            className="panel-section-child1"
                          />
                          <TextDisplay
                            label="Email :"
                            value={coBuyerFormData.emailId}
                            className="panel-section-child1"
                          />
                          {coBuyerFormData.corporationName && (
                            <TextDisplay
                              label="Corporation Name :"
                              value={coBuyerFormData.corporationName}
                              className="panel-section-child1"
                            />
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* //THIS IS THE THIRD ACCORDIAN */}
            {showAccordian3 && (
              <div className="accordion-item" ref={accordian3Ref}>
                <div className="purchase-prof-accordion-header accordion-header-responsive">
                  <div ref={accordianRef} className="d-flex align-items-center">
                    {accordian3EditBtnActive && accordian3FormCompleted ? (
                      <CheckIcon isActive={true} />
                    ) : (
                      <CheckIcon isActive={false} />
                    )}
                    <span className="panel-title">Agent's Information</span>
                  </div>

                  {isAccordianDataPreFilled && !showAccordian3Body && (
                    <span className="panel-subTxt">
                      Information has been pre-filled with the selected purchase
                      profile.
                    </span>
                  )}

                  {accordian3EditBtnActive && (
                    <div
                      className="panel-edit-btn"
                      onClick={() => {
                        setShowAccordian3Body(true);
                        setAccordian3EditBtnActive(false);
                        setAccordian3FormCompleted(false);
                        setShowAccordian1Body(false);
                        setAccordian1EditBtnActive(true);
                        setAccordian1FormCompleted(true);
                        setShowAccordian2Body(false);
                        setAccordian2EditBtnActive(true);
                        !isNewTemplate && setAccordian2FormCompleted(true);
                      }}
                    >
                      Edit
                    </div>
                  )}
                </div>

                {showAccordian3Body && (
                  <div className="accordion-body">
                    <Form>
                      <Row className="mx-2">
                        <p className="pannel-accordian2-para custom-col-padding">
                          As this profile information will be used to bind legal
                          contract, please ensure to add information correctly.
                          Missing information and/ or inaccurate information can
                          cause the contract to be rejected.
                        </p>
                        {agentInfoField.map((item, index) => (
                          <Col
                            sm={12}
                            md={6}
                            xs={12}
                            key={index}
                            className="g-4 custom-col-padding"
                          >
                            <label
                              htmlFor={item.placeholder}
                              className="form-label pp-form-label"
                            >
                              {item.label}
                              {item.required && (
                                <span className="text-danger">*</span>
                              )}
                            </label>
                            {item.type === "dropdown" ? (
                              <Form.Select
                                ref={(el) =>
                                  (agentFormRef.current[item.formValueLabel] =
                                    el)
                                }
                                className="form-select pp-dropdown pp-responsive-font"
                                value={agentInfo[item.formValueLabel] || ""}
                                name={item.formValueLabel}
                                required={item.required}
                                id={item.placeholder}
                                onChange={handleAgentFieldChange}
                                style={{
                                  padding: "12px",
                                }}
                              >
                                <option value="">{item.placeholder}</option>

                                {[
                                  "state",
                                  "individualLicenceState",
                                  "corporationState",
                                ].includes(item.formValueLabel)
                                  ? (stateList || []).map((option) => (
                                      <option key={option} value={option}>
                                        {option}
                                      </option>
                                    ))
                                  : null}
                              </Form.Select>
                            ) : item.formValueLabel === "city" ? (
                              <SuggestionInput
                                inputRef={(el) =>
                                  (agentFormRef.current[item.formValueLabel] =
                                    el)
                                }
                                type={item.type}
                                formType="agent"
                                id={item.placeholder}
                                setError={setAgentErrorValidate}
                                placeholder={item.placeholder}
                                className="form-control pp-input-field"
                                value={agentInfo[item.formValueLabel] || ""}
                                onChange={handleAgentFieldChange}
                                name={item.formValueLabel}
                                required={item.required}
                                cityLoaded={locationData.agent.loaded}
                                suggestions={locationData.agent.cities || []}
                              />
                            ) : item.formValueLabel === "phoneNumber" &&
                              isPhoneVerified.agentVerificationRequired ? (
                              <PhoneInputField
                                item={item}
                                formRef={(el) =>
                                  (agentFormRef.current[item.formValueLabel] =
                                    el)
                                }
                                value={agentInfo[item.formValueLabel]}
                                onChange={handleAgentFieldChange}
                                onBlur={handleAgentFieldChange}
                                type={item.type}
                                id={item.placeholder}
                                isVerified={isPhoneVerified.agentNumVerified}
                                setShowVerifyModal={() =>
                                  setVerificationModalState({
                                    isOpen: true,
                                    phoneNumber: agentInfo.phoneNumber,
                                    type: "agent",
                                  })
                                }
                              />
                            ) : (
                              <Form.Control
                                ref={(el) =>
                                  (agentFormRef.current[item.formValueLabel] =
                                    el)
                                }
                                type={item.type}
                                maxLength={item.maxLength}
                                className="form-control pp-input-field"
                                id={item.placeholder}
                                readOnly={
                                  item.type === "email" &&
                                  selectedDescription === "Agent" &&
                                  agentBuyingForSelf === "No"
                                }
                                placeholder={item.placeholder}
                                value={
                                  item.formValueLabel === "phoneNumber"
                                    ? formatPhoneNumber(
                                        agentInfo[item.formValueLabel]
                                      )
                                    : agentInfo[item.formValueLabel] || ""
                                }
                                onChange={(e) => {
                                  if (item.type === "date" && e.target.value) {
                                    // Limit year to 4 digits
                                    const dateValue = e.target.value;

                                    const dateParts = dateValue.split("-");
                                    if (
                                      dateParts.length === 3 &&
                                      dateParts[0].length > 4
                                    ) {
                                      dateParts[0] = dateParts[0].substring(
                                        0,
                                        4
                                      );

                                      e.target.value = dateParts.join("-");
                                    }
                                  }
                                  handleAgentFieldChange(e);
                                }}
                                onBlur={handleAgentFieldChange}
                                name={item.formValueLabel}
                                required={item.required}
                              />
                            )}

                            {agentErrorValidate.errors &&
                              agentErrorValidate.errors[
                                item.formValueLabel
                              ] && (
                                <div
                                  className={
                                    agentErrorValidate.errors[
                                      item.formValueLabel
                                    ].includes(
                                      "We will text you one time verification code"
                                    )
                                      ? "pp-error-message text-secondary"
                                      : "pp-error-message"
                                  }
                                >
                                  {agentErrorValidate.errors &&
                                    agentErrorValidate.errors[
                                      item.formValueLabel
                                    ] && (
                                      <div
                                        className={
                                          agentErrorValidate.errors[
                                            item.formValueLabel
                                          ].includes(
                                            "We will text you one time verification code"
                                          )
                                            ? "pp-error-message text-secondary"
                                            : "pp-error-message"
                                        }
                                      >
                                        {item.formValueLabel ===
                                          "individualLicencenNumber" &&
                                        showLicenseTooltip ? (
                                          <span>
                                            Invalid License Format
                                            <OverlayTrigger
                                              placement="right"
                                              overlay={
                                                <Tooltip
                                                  id="license-tooltip"
                                                  style={{
                                                    fontSize: "0.75rem",
                                                  }}
                                                >
                                                  {
                                                    agentErrorValidate.errors[
                                                      item.formValueLabel
                                                    ]
                                                  }
                                                </Tooltip>
                                              }
                                            >
                                              <span className="ms-2">
                                                <i className="bi bi-info-circle"></i>
                                              </span>
                                            </OverlayTrigger>
                                          </span>
                                        ) : (
                                          agentErrorValidate.errors[
                                            item.formValueLabel
                                          ]
                                        )}
                                      </div>
                                    )}
                                </div>
                              )}
                          </Col>
                        ))}
                      </Row>
                      <Button
                        className="purchase-prof-continue-btn mt-4"
                        onClick={() => handleAccordianSubmit(3)}
                      >
                        {isFormSubmitLoading ? (
                          <LoadingText text="Verifying..." />
                        ) : (
                          <LoadedText
                            text={`${isNewTemplate ? "Create" : "Update"}`}
                          />
                        )}
                      </Button>
                    </Form>
                  </div>
                )}

                {accordian3FormCompleted && agentInfo.firstName && (
                  <div className="panel-section-head">
                    <div className="closed-view-sub-title">Buyer's Agent</div>
                    <div className="pannel-section-container">
                      <div className="pannel-section-left-container pannel-section-left-container-lisc">
                        <TextDisplay
                          label="Name :"
                          value={agentInfo.firstName + " " + agentInfo.lastName}
                        />
                        <TextDisplay
                          label="Email :"
                          value={agentInfo.emailId}
                        />
                        <TextDisplay
                          label="Agency Name :"
                          value={agentInfo.corporationName}
                        />
                      </div>
                      <div className="pannel-section-right-container">
                        <TextDisplay
                          label="Individual License Number :"
                          value={agentInfo.individualLicencenNumber}
                        />
                        <TextDisplay
                          label="Individual License Expiration Date :"
                          value={convertYYYYMMDDtoMMDDYYYY(
                            agentInfo.individualLicenceExpiryDate
                          )}
                        />
                        <TextDisplay
                          label="Individual License State :"
                          value={agentInfo.individualLicenceState}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </Container>

        <div className="d-sm-block d-md-none">
          {!isNewTemplate && (
            <>
              <div className="panel-section-text-right">
                <button
                  className="purchase-profile-delete-btn-sm"
                  onClick={() => {
                    setIsDeleteModalActive(true);
                    trackButtonClick({
                      eventName: "delete_clicked",
                      eventCategory: "my-shopper",
                      eventLabel: "SRC : Buyer Dashboard My Purchase Profile",
                      eventSource: "on delete purchase profile click",
                    });
                  }}
                >
                  Delete
                </button>
                this purchase profile
              </div>
              <div class="del-content-2">
                You will not be able to reactivate your profile or retrieve any
                of the content or information in your profile.
              </div>
            </>
          )}
        </div>
      </Row>
    </div>
  );
};

export default PurchaseProfileForm;
